<template>
  <div class="wing-layout">
    <div class="main-wrap">
      <!-- new right start-->
      <div id="main-content">
        <div class="wrapper">
          <jm-crumbs :append="[this.editData.custom_name]"/>
          <div class="table-agile-info">
            <!-- 星图系统tab -->
            <div class="edit-bg-wrap">
              <info-menu :is-new="isNew" :show-more.sync="hiddenIs" :read-only.sync="infoReadOnly" />
              <div class="basic-information"><!-- 虚线验证在form 加 error-form ref="editDataForm":rules="rules"-->
                <el-form
                  :model="editData"
                  class="error-form basic-table basic-table-div"
                  :disabled="!isFibSite || isSnapshot"
                >
                  <el-collapse v-model="activeNames">
                    <el-collapse-item
                      title="基本信息"
                      name="1">
                      <el-row>
                        <el-col :span="1">姓名</el-col>
                        <el-col :span="5">
                          <el-input
                            :readonly="infoReadOnly"
                            v-model="editData['custom_name']"
                            :class="['jm-input-common4', isDiffValue('custom_name')]"
                            autofocus="autofocus"/>
                        </el-col>
                        <el-col :span="1">昵称</el-col>
                        <el-col :span="5">
                          <el-input
                            :readonly="infoReadOnly"
                            v-model="editData['custom_nickname_tell']"
                            :class="['jm-input-common4', isDiffValue('custom_nickname_tell')]"/>
                        </el-col>
                        <el-col :span="1">采集功能</el-col>
                        <el-col :span="5" v-if="!isNew || !isFibSite">{{ editData.create_point_value }}({{ editData.create_time }})</el-col>
                        <el-col :span="5" v-else>
                          <el-select
                            :disabled="infoReadOnly"
                            filterable
                            v-model="editData['create_point']"
                            class="jm-input-common4"
                            clearable
                            placeholder="请选择">
                            <template v-for="item in ds.create_point">
                              <el-option
                                v-if="item.adminView === 1 || $hasPermission([52])"
                                :key="item.userid"
                                :label="item.username"
                                :value="item.userid"/>
                            </template>
                          </el-select>
                        </el-col>
                        <el-col :span="1">推广人</el-col>
                        <el-col
                          :span="5"
                          v-if="(!isNew || !isFibSite) && !$hasPermission([])">{{ editData.custom_promoter_value }}</el-col>
                        <el-col
                          :span="5"
                          v-else>
                          <el-select
                            :disabled="infoReadOnly"
                            filterable
                            v-model="editData['custom_promoter']"
                            class="jm-input-common4"
                            clearable
                            placeholder="请选择">
                            <el-option-group
                              v-for="(group, k) in ds.create_person"
                              :key="k"
                              :label="k">
                              <el-option
                                v-for="item in group"
                                :key="item.userid"
                                :label="item.username"
                                :value="item.userid"/>
                            </el-option-group>
                          </el-select>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="1">电话</el-col>
                        <el-col :span="5">
                          <el-form-item prop="crm_tel">
                            <el-input
                              ref="telInput"
                              :readonly="(infoReadOnly && !canEditByCreator)"
                              v-model.trim="editData['crm_tel']"
                              @blur="checkTel"
                              :class="['', isDiffValue('crm_tel')]">
                              <template slot="prepend">{{ editData['char'] }}-</template>
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="1">归属地区</el-col>
                        <el-col :span="5">{{ editData.crm_tel_province }} {{ editData.crm_tel_city }}</el-col>
                        <el-col :span="1">QQ</el-col>
                        <el-col :span="5">
                          <el-form-item prop="crm_qq">
                            <el-input
                              :readonly="(infoReadOnly && !canEditByCreator)"
                              v-model.trim="editData['crm_qq']"
                              @blur="checkQQ"
                              :maxlength="20"
                              :class="['jm-input-common4', isDiffValue('crm_qq')]"/>
                          </el-form-item>
                        </el-col>
                        <el-col :span="1">微信</el-col>
                        <el-col :span="5">
                          <el-form-item prop="crm_weixin">
                            <el-input
                              :readonly="(infoReadOnly && !canEditByCreator)"
                              v-model.trim="editData['crm_weixin']"
                              @blur="checkWx"
                              :class="['jm-input-common4', isDiffValue('crm_weixin')]"/>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="1">入学时间</el-col>
                        <el-col :span="5">
                          <el-date-picker
                            :readonly="infoReadOnly"
                            v-model="editData['custom_year']"
                            type="year"
                            format="yyyy"
                            value-format="yyyy"
                            placeholder="请选择"
                            ref="customer_year"
                            :class="['jm-input-common5', isDiffValue('custom_year')]"
                          />
                          <el-date-picker
                            :readonly="infoReadOnly"
                            :disabled="!editData['custom_year']"
                            v-model="editData['custom_month']"
                            format="MM"
                            value-format="MM"
                            type="month"
                            placeholder="请选择"
                            :class="['jm-input-common5', isDiffValue('custom_month')]"
                            popper-class="process-list-popper"
                          />
                        </el-col>
                        <el-col :span="1">客户分级</el-col>
                        <el-col :span="5">
                          <jm-dict-select
                            :disabled="infoReadOnly && !isOptManager && !isDataAnalyst && !(canEditByCreator && originLevel === 64)"
                            class="jm-input-common4"
                            type="dataset"
                            @change="bindUserStatus"
                            v-model="editData['crm_level_lv']"
                            dict-type="student"
                            name="customLvType"
                            :filter="crmLevelFilter"/>
                        </el-col>
                        <el-col :span="1">身份</el-col>
                        <el-col :span="5">
                          <jm-dict-select
                            clearable
                            :disabled="infoReadOnly"
                            class="jm-input-common4"
                            type="dataset"
                            v-model="editData['identity']"
                            dict-type="student"
                            name="identity"/>
                        </el-col>
                        <el-col :span="1">微信名片</el-col>
                        <el-col :span="5">
                          <jm-upload
                            :show-file-list="false"
                            action="/newfib.php/index/api_base/uploadSimpleFile/type/wxid"
                            :on-success="uploadWxidSuccess"
                          >
                            <slot>
                              <el-button type="warning" size="medium">
                                <i class="el-icon-document"></i>上传截图
                              </el-button>
                            </slot>
                          </jm-upload>
                          <el-button v-show="editData['wxid_file'] !== ''" @click="downloadWxid">
                            <i class="el-icon-document"></i>下载截图
                          </el-button>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="1" :style="education[0] ? 'color: #010D2D' : 'color: red'">最高学历</el-col>
                        <el-col :span="5" class="edit-dictselect">
                          <jm-education-select
                            :disabled="infoReadOnly"
                            v-model="education"
                            clearable/>
                        </el-col>
                        <el-col :span="1">客户评级</el-col>
                        <el-col
                          :span="5">
                          <jm-dict-select
                            class="jm-input-common4"
                            clearable
                            type="dataset"
                            name="studentLevel"
                            dict-type="student"
                            v-model.number="editData['student_level']"/>
                        </el-col>
                        <el-col :span="1">线索分级</el-col>
                        <el-col :span="5">
                          <jm-dict-select
                            :disabled="infoReadOnly"
                            class="jm-input-common4"
                            v-model="editData['clues_level']"
                            type="dataset"
                            name="cluesLevel"
                            dict-type="student"
                            clearable/>
                        </el-col>
                        <el-col :span="1">留学目的</el-col>
                        <el-col :span="5">
                          <jm-dict-select
                            :disabled="infoReadOnly"
                            class="jm-input-common4"
                            v-model="editData['custom_jp_note']"
                            dict-type="custom_jp_note"
                            clearable/>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="1">渠道来源</el-col>
                        <el-col
                          :span="11"
                          :class="isDiffValue('custom_from')">
                          <jm-channel
                            v-if="isFibSite"
                            v-model="channels"
                            :disabled="!$hasPermission([1, 52]) && !isNew || infoReadOnly"
                            :exclude-disable="!$hasPermission([1, 52]) && !isNew || infoReadOnly"
                            :is-all="false"
                            :final.sync="channelFinal"
                            clearable
                            ref="channelRef"
                            filterable/>
                          <span v-else>{{ editData.channelsData }}</span>
                        </el-col>
                        <el-col :span="1">加盟商</el-col>
                        <el-col :span="11">{{ editData['league_channel'] }}</el-col>
                      </el-row>
                      <el-row v-if="editData.cms_member">
                        <el-col :span="1">资源画像</el-col>
                        <el-col :span="23">
                          <el-tag class="member-tag" v-if="editData.cms_member.educationText" type="danger">学历：{{ editData.cms_member.educationText }}</el-tag>
                          <el-tag class="member-tag" v-if="editData.cms_member.planTime" type="danger">计划出国时间: {{ editData.cms_member.planTime }}</el-tag>
                          <el-tag class="member-tag" v-if="false && editData.cms_member.device_name" type="danger">机型: {{ editData.cms_member.device_name }}</el-tag>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="1">是否已拍订单</el-col>
                        <el-col :span="5">
                          <el-select
                            :disabled="!isNew || channels.custom_from !== 118"
                            class="jm-input90"
                            v-model="editData['take_order']">
                            <el-option
                              label="否"
                              :value="0"></el-option>
                            <el-option
                              label="是"
                              :value="1"></el-option>
                          </el-select>
                          <el-input
                            style="margin:0 8px"
                            :readonly="!isNew || !editData['take_order']"
                            v-model="editData['take_order_number']"
                            class="jm-input220"/>
                        </el-col>
                        <template v-if="this.editData.custom_hope_country.indexOf(2061)!==-1">
                          <el-col :span="1">说明</el-col>
                          <el-col :span="11">
                            <el-select
                              :disabled="infoReadOnly"
                              clearable
                              class="jm-input-common4"
                              v-model="editData['singapore_explain']"
                              placeholder="请选择">
                              <el-option
                                v-for="item in singapore_explain"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                              </el-option>
                            </el-select>
                            <span class="colour" style="margin-left: 8px">*(意向国家为新加坡时必填)</span>
                          </el-col>
                          <el-col :span="6"></el-col>
                        </template>
                        <el-col v-else :span="18"/>
                      </el-row>
                      <el-row>
                        <el-col :span="1">介绍人ID </el-col>
                        <el-col :span="5">
                          <el-input
                            :disabled="true"
                            v-model="editData['parent_id']"
                            class= "jm-input-common4"
                          />
                        </el-col>
                        <el-col :span="1">介绍人<br>姓名 </el-col>
                        <el-col :span="5">
                          <el-input
                            :disabled="true"
                            v-model="editData['bind_name']"
                            class= "jm-input-common4"
                          />
                        </el-col>
                        <template v-if="showMoneyVisible">
                          <el-col :span="1"><font color="#F75694">家庭可支配收入</font></el-col>
                          <el-col :span="11">
                            <el-select
                              class="jm-input-common4"
                              v-model="editData['money']">
                              <el-option
                                label="请选择"
                                :value="0"></el-option>
                              <el-option
                                label="0-50万"
                                :value="1"></el-option>
                              <el-option
                                label="50-100万"
                                :value="2"></el-option>
                              <el-option
                                label="100-200万"
                                :value="3"></el-option>
                              <el-option
                                label="200万以上"
                                :value="4"></el-option>
                            </el-select>
                          </el-col>
                        </template>
                        <el-col v-else :span="12"></el-col>
                      </el-row>
                      <el-row class="hope_country">
                        <el-col :span="1">意向国家</el-col>
                        <el-col style="flex-wrap: wrap" :class="countryCheckboxLock[0] && editData['custom_hope_country'].length > 0 ? 'col-border-light' : ''">
                          <el-checkbox-group v-model="editData['custom_hope_country']" v-show="countryCheckboxLock[0] === false && editData['custom_hope_country'].length > 0">
                            <el-checkbox
                              v-for="item in hopeCountries"
                              v-show="editData['custom_hope_country'].indexOf(item.id) > -1"
                              :label="item.id"
                              :key="item.id"
                              :disabled="isDisabledCountry(item.id)">{{ item.value }}</el-checkbox>
                          </el-checkbox-group>
                          <el-checkbox-group v-model="editData['custom_hope_country']" v-show="countryCheckboxLock[0] === true || editData['custom_hope_country'].length < 1">
                            <el-checkbox
                              v-for="item in hopeCountries"
                              :label="item.id"
                              :key="item.id"
                              :disabled="isDisabledCountry(item.id)">{{ item.value }}</el-checkbox>
                          </el-checkbox-group>
                          <div style="width: 100%; padding-bottom: 10px" v-show="editData['custom_hope_country'].length > 0">
                            <el-button
                              class="country-button"
                              type="primary"
                              size="medium"
                              @click="countryCheckboxClick(1)">{{ countryCheckboxLock[0] ? '收起国家' : '更多国家' }}</el-button>
                          </div>
                        </el-col>
                      </el-row>
                      <el-row v-if="!isSnapshot">
                        <el-col :span="1">资源互转</el-col>
                        <el-col :span="5">
                          <el-select
                            :disabled="infoReadOnly"
                            class="jm-input-common4"
                            clearable
                            v-model="editData['crm_zhuanxiang']"
                            placeholder="请选择">
                            <el-option
                              label="芥末转前程"
                              :value="1">芥末转前程</el-option>
                            <el-option
                              label="前程转芥末"
                              :value="2">前程转芥末</el-option>
                            <el-option
                              label="call center激活"
                              :value="3">call center激活</el-option>
                          </el-select>
                        </el-col>
                        <el-col :span="1">服务切片</el-col>
                        <el-col :span="5">
                          <el-select
                            :disabled="infoReadOnly"
                            clearable
                            class="jm-input-common4"
                            v-model="editData['country_business']"
                            placeholder="请选择">
                            <el-option
                              v-for="item in servicesData"
                              :key="item.id"
                              :label="`[${item.country}]${item.value}`"
                              :value="item.id"/>
                          </el-select>
                        </el-col>
                        <template v-if="hasSignType">
                          <el-col :span="1">签约类型</el-col>
                          <el-col :span="10">
                            <el-radio-group
                              :max="1"
                              size="mini"
                              v-model="signTypeLevel"
                              @change="radioGroupChange">
                              <el-radio
                                @click.native="clearSignTypeLevel(1)"
                                v-if="hasStandard"
                                :label="1">Standard</el-radio>
                              <el-radio
                                @click.native="clearSignTypeLevel(2)"
                                v-if="hasPlus"
                                :label="2">Plus</el-radio>
                              <el-radio
                                @click.native="clearSignTypeLevel(3)"
                                v-if="canFree"
                                :label="3">Free</el-radio>
                            </el-radio-group>
                            <el-checkbox-group
                              v-model="signTypeKind"
                              @change="checkboxGroupChange"
                              style="margin-left: 10px">
                              <el-checkbox :label="4">短期</el-checkbox>
                              <el-checkbox :label="5">语培</el-checkbox>
                            </el-checkbox-group>
                          </el-col>
                        </template>
                        <el-col v-else :span="12"/>
                      </el-row>
                      <el-row v-if="isJiemoJpStudent">
                        <el-col :span="1">芥末日本vip</el-col>
                        <el-col :span="5">
                          <el-select
                            class="jm-input-common4"
                            v-model="editData['jiemo_vip']">
                            <el-option
                              label="否"
                              :value="0"></el-option>
                            <el-option
                              label="是"
                              :value="1"></el-option>
                          </el-select>
                        </el-col>
                        <el-col :span="1">短期留学</el-col>
                        <el-col :span="5">
                          <el-select
                            :disabled="infoReadOnly"
                            class="jm-input-common4"
                            v-model="editData['short_study_abroad']">
                            <el-option
                              label="否"
                              :value="0"/>
                            <el-option
                              label="是"
                              :value="1"/>
                          </el-select>
                        </el-col>
                        <el-col :span="12"/>
                      </el-row>

                      <el-row>
                        <el-col :span="1">是否确认服务签约</el-col>
                        <el-col :span="5">
                          <el-select
                            disabled
                            class="jm-input-common4"
                            v-model="contractSign">
                            <el-option
                              label="contractSign"
                              :value="0"></el-option>
                          </el-select>
                        </el-col>
                        <el-col :span="1">是否确认VIP签约</el-col>
                        <el-col :span="5">
                          <el-select
                            disabled
                            class="jm-input-common4"
                            v-model="vipSign">
                            <el-option
                              label="vipSign"
                              :value="0"></el-option>
                          </el-select>
                        </el-col>
                        <el-col :span="12" />
                      </el-row>
                      <el-row>

                        <el-col :span="1">家长社群</el-col>
                        <el-col :span="5">
                          <el-select
                            class="jm-input-common4"
                            v-model="editData['is_parent_community']">
                            <el-option label="否" :value="0"></el-option>
                            <el-option label="是" :value="1"></el-option>
                          </el-select>
                        </el-col>
                        <el-col :span="1">芥末会员</el-col>
                        <el-col :span="5">
                          <el-select
                            class="jm-input-common4"
                            v-model="editData['is_vip']">
                            <el-option label="否" :value="0"></el-option>
                            <el-option label="是" :value="1"></el-option>
                          </el-select>
                        </el-col>
                        <el-col :span="6"/>
                      </el-row>
                      <el-row>
                        <el-col :span="1" style="height: 160px">备注</el-col>
                        <el-col :span="23">
                          <el-input
                            class="textarea-largesize"
                            :readonly="infoReadOnly"
                            type="textarea"
                            :rows="2"
                            placeholder="请输入备注"
                            v-model="editData['crm_memo']"/>
                        </el-col>
                      </el-row>
                      <el-row v-if="editData['sync'] && editData['sync'].length >= 1">
                        <el-col>
                          <div class="red">
                            <p v-for="(sync, k) in editData['sync']" :key="k">【资源内推{{ sync.create_time }}】{{ sync.sender_department }}-{{ sync.sender }}老师给您留言：{{ sync.note }}</p>
                          </div>
                        </el-col>
                      </el-row>
                      <el-row v-if="editData['sync1'] && editData['sync1'].length >= 1">
                        <el-col>
                          <div style="color:blue">
                            <p v-for="(sync, k) in editData['sync1']" :key="k">【留学内推{{ sync.create_time }}】{{ sync.sender }}老师，推送留学协同资源</p>
                          </div>
                        </el-col>
                      </el-row>
                      <el-row v-if="!isNew">
                        <el-col :span="24">
                          <div style="font-size: 20px; font-weight: bold; padding: 0 10px">资源复用记录</div>
                        </el-col>
                        <el-col :span="24">
                          <jm-tableList
                            style="width: 100%"
                            url="/index/reuse/getList"
                            :search-data="{userid: $route.params.id, origin_tag: siteName}"
                            row-key="id"
                          >
                            <el-table-column
                              slot="url"
                              label="截图"
                              min-width="80">
                              <template slot-scope="scope">
                                <img style="max-height: 40px; cursor: pointer" @click="viewBigImg(scope.row.url)" :src="scope.row.url" alt="">
                              </template>
                            </el-table-column>
                          </jm-tableList>
                        </el-col>
                      </el-row>
                    </el-collapse-item>
                    <el-collapse-item
                      title="签约信息"
                      name="2"
                      v-if="!isSnapshot">
                      <sign-info-form
                        :form-data.sync="editData"
                        :ds="ds"
                        :teachers="teachers"
                        ref="signInfoForm"
                      />
                    </el-collapse-item>
                    <el-collapse-item
                      title="前程专有"
                      name="3"
                      v-show="qcrbPropIs">
                      <el-row>
                        <el-col :span="1">签约类型</el-col>
                        <el-col :span="2">
                          <el-select v-model="editData.custom_course_type" v-if="$hasPermission([])">
                            <el-option :value="1" label="语言学校"/>
                            <el-option :value="2" label="前程日本研究生"/>
                          </el-select>
                          <span v-else>{{ signType }}</span>
                        </el-col>
                        <el-col :span="1">客服老师</el-col>
                        <el-col :span="5">
                          <el-select
                            :disabled="!canEditCse"
                            class="jm-input-common4"
                            v-model="editData['crm_cse']"
                            placeholder="请选择"
                            clearable>
                            <el-option-group
                              v-for="(group, k) in customerTeacher"
                              :key="k"
                              :label="k">
                              <el-option
                                v-for="item in group"
                                :key="item.userid"
                                :label="item.truename"
                                :value="item.userid"/>
                            </el-option-group>
                          </el-select>
                        </el-col>
                        <el-col :span="1">客户经理</el-col>
                        <el-col :span="5">
                          <el-select
                            :disabled="!canEditManager"
                            class="jm-input-common4"
                            v-model="editData['crm_manager']"
                            placeholder="请选择"
                            clearable>
                            <el-option-group
                              v-for="(group, k) in teachers.manager_teacher"
                              :key="k"
                              :label="k">
                              <el-option
                                v-for="item in group"
                                :key="item.userid"
                                :label="item.truename"
                                :value="item.userid"/>
                            </el-option-group>
                          </el-select>
                        </el-col>
                        <el-col :span="1">评星等级</el-col>
                        <el-col :span="5">
                          <jm-dict-select
                            :disabled="[176916, 176914].indexOf(userInfo.userid) == -1"
                            class="jm-input-common4"
                            :filter="(item) => { item.value !== 6; }"
                            clearable
                            type="dataset"
                            dict-type="student"
                            name="crmStar"
                            v-model="editData['crm_star']"/>
                        </el-col>
                      </el-row>
                    </el-collapse-item>
                    <div
                      class="jm-studentEditBot">
                      <el-collapse-item
                        title="个人信息"
                        name="4">
                        <el-row>
                          <el-col :span="1">民族</el-col>
                          <el-col :span="5">
                            <el-input
                              :readonly="infoReadOnly"
                              v-model="editData['crm_nation']"
                              class="jm-input-common4"/>
                          </el-col>
                          <el-col :span="1" :style="editData['custom_birthday'] ? 'color: #010D2D' : 'color: red'">生日</el-col>
                          <el-col :span="5">
                            <el-date-picker
                              :readonly="infoReadOnly"
                              class="jm-input-common4"
                              v-model="editData['custom_birthday']"
                              type="date"
                              placeholder="选择日期"
                              format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd"/>
                          </el-col>
                          <el-col :span="1" :style="domicile[1] ? 'color: #010D2D' : 'color: red'">户籍地</el-col>
                          <el-col :span="11" class="edit-dictselect">
                            <jm-areaselect
                              :disabled="infoReadOnly"
                              v-model="domicile"/>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="1" :style="editData['custom_sex'] ? 'color: #010D2D' : 'color: red'">性别</el-col>
                          <el-col :span="5">
                            <jm-dict-select
                              :disabled="infoReadOnly"
                              class="jm-input-common4"
                              clearable
                              type="dataset"
                              v-model="editData['custom_sex']"
                              dict-type="student"
                              name="gender"/>
                          </el-col>
                          <el-col :span="1">毕业时间</el-col>
                          <el-col :span="11">
                            <el-date-picker
                              :readonly="infoReadOnly"
                              class="jm-input-common4"
                              v-model="editData['custom_graduation']"
                              align="right"
                              format="yyyy"
                              value-format="yyyy"
                              type="year"
                              placeholder="选择年"/>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="1">出国资金</el-col>
                          <el-col :span="5">
                            <jm-dict-select
                              :disabled="infoReadOnly"
                              clearable
                              class="jm-input-common4"
                              dict-type="money_all"
                              v-model="editData['custom_money']"/>
                          </el-col>
                          <el-col :span="1">有无<br>拒签史</el-col>
                          <el-col :span="11">
                            <el-select
                              :disabled="infoReadOnly"
                              clearable
                              class="jm-input-common4"
                              v-model="editData['custom_refusal']"
                              placeholder="请选择">
                              <el-option
                                label="无"
                                :value="1">无</el-option>
                              <el-option
                                label="有"
                                :value="2">有</el-option>
                            </el-select>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-row class="first-line" v-if="!infoReadOnly">
                            <el-col :span="24">
                              <el-button
                                type="primary"
                                class="addSchoolBtn"
                                size="medium"
                                @click="addNewschool">添加毕业学校</el-button>
                            </el-col>
                          </el-row>
                          <el-radio-group v-model="isRadio">
                            <jm-school
                              v-for="(num, index) in gschoolList"
                              :is-radios.sync="isRadio"
                              :key="num.id"
                              :school-num="index"
                              :crm-id="editData.id"
                              :obj.sync="num"
                              ref="gschools"
                              :schoolarr.sync="gschoolList"
                              :can-save="!infoReadOnly"/>
                          </el-radio-group>
                        </el-row>
                        <el-row>
                          <el-col :span="2">户籍地详细</el-col>
                          <el-col :span="22">
                            <el-input
                              :readonly="infoReadOnly"
                              type="textarea"
                              :rows="2"
                              placeholder="请输入详细地址"
                              v-model="editData['custom_place_detail']"/>
                          </el-col>
                        </el-row>
                      </el-collapse-item>
                      <!-- 报名表信息 start -->
                      <interview-form ref="interviewForm" v-if="isFibSite && !isSnapshot && !isNew" />
                      <!-- 报名表信息 end -->
                      <!-- 报名表信息 start -->
                      <qc-info-form v-if="true" :user-id="$route.params.id" />
                      <!-- 报名表信息 end -->
                      <el-collapse-item
                        title="成绩信息"
                        name="5"
                        v-if="showScores">
                        <el-row>
                          <el-col :span="1">App<br>备注</el-col>
                          <el-col :span="23">
                            <el-input
                              :readonly="infoReadOnly"
                              type="textarea"
                              :disabled="true"
                              v-model="editData['custom_app_note']"/>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="1">均分<br>GPA</el-col>
                          <el-col :span="23">
                            <el-input
                              :readonly="infoReadOnly && !isKaopei"
                              v-model="editData['custom_avg_score']"
                              class="jm-input280"/>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="1">高考分数</el-col>
                          <el-col :span="23">
                            <el-input
                              :readonly="infoReadOnly && !isKaopei"
                              type="number"
                              :max="8"
                              v-model="editData['custom_examination_scores']"
                              class="jm-input280"/>
                          </el-col>
                        </el-row>
                        <el-row v-if="$inCountry([83, 485, 1868])">
                          <el-col
                            :span="1"
                            class="scores-info">
                            <el-row>
                              <el-col style="height: 110px">日语能力</el-col>
                            </el-row>
                          </el-col>
                          <el-col
                            :span="23"
                            class="scores-jmte">
                            <el-row style="width: 87%; display: block; height: 111px;">
                              <el-col
                                :span="24"
                                style="height: 111px;">
                                <p >是否有日语成绩：</p>
                                <el-select
                                  v-model="editData['has_jp_score']"
                                  clearable
                                  :disabled="infoReadOnly && !isKaopei"
                                  placeholder="请选择">
                                  <el-option
                                    :key="1"
                                    label="是"
                                    :value="1"/>
                                  <el-option
                                    :key="2"
                                    label="否"
                                    :value="2"/>
                                </el-select>
                              </el-col>
                            </el-row>
                            <el-row style="width: 100%; display: block;">
                              <el-col :span="24">
                                <span class="jm-span">JLPT：</span>
                                <jm-dict-select
                                  :disabled="infoReadOnly && !isKaopei"
                                  class="jm-input135"
                                  clearable
                                  v-model="scores[89].ln_level"
                                  dict-type="examjp_d"
                                  :filter="item => item.pid === 89"/>&nbsp;
                                  总：
                                <el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[89].ln_all"
                                  class="jm-input65"/>
                              </el-col>
                              <el-col :span="24">
                                <span class="jm-span">BJT：</span>
                                <jm-dict-select
                                  :disabled="infoReadOnly && !isKaopei"
                                  class="jm-input135"
                                  clearable
                                  v-model="scores[91].ln_level"
                                  dict-type="examjp_d"
                                  :filter="item => item.pid === 91"/>&nbsp;
                                  总：
                                <el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[91].ln_all"
                                  class="jm-input65"/>
                              </el-col>
                            </el-row>
                            <el-row style="width: 100%; display: block;">
                              <el-col :span="24">
                                <span class="jm-span">J-TEST：</span>
                                <jm-dict-select
                                  :disabled="infoReadOnly && !isKaopei"
                                  class="jm-input135"
                                  clearable
                                  v-model="scores[90].ln_level"
                                  dict-type="examjp_d"
                                  :filter="item => item.pid === 90"/>&nbsp;
                                  总：
                                <el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[90].ln_all"
                                  class="jm-input65"/>
                              </el-col>
                              <el-col :span="24">
                                <span class="jm-span">NAT：</span>
                                <jm-dict-select
                                  :disabled="infoReadOnly && !isKaopei"
                                  class="jm-input135"
                                  clearable
                                  v-model="scores[92].ln_level"
                                  dict-type="examjp_d"
                                  :filter="(item) => item.pid === 92"/>&nbsp;
                                  总：
                                <el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[92].ln_all"
                                  class="jm-input65"/>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col
                            :span="1"
                            class="scores-info">
                            <el-row>
                              <el-col style="height: 165px">英语成绩</el-col>
                            </el-row>
                          </el-col>
                          <el-col
                            :span="23"
                            class="scores-jmte">
                            <el-row style="width: 87%; display: block; height: 164px;">
                              <el-col
                                :span="24"
                                style="height: 164px;">
                                <p >是否有英语成绩：</p>
                                <el-select
                                  v-model="editData['has_en_score']"
                                  clearable
                                  :disabled="infoReadOnly && !isKaopei"
                                  placeholder="请选择">
                                  <el-option
                                    :key="1"
                                    label="是"
                                    :value="1"/>
                                  <el-option
                                    :key="2"
                                    label="否"
                                    :value="2"/>
                                </el-select>
                              </el-col>
                            </el-row>
                            <el-row style="width: 100%; display: block;">
                              <el-col :span="24">
                                <span class="jm-span">『 TOEFL 』</span>
                                L：<el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[23].ln_listen"
                                  class="jm-input50"/>
                                &nbsp;R：<el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[23].ln_read"
                                  class="jm-input50"/>
                                &nbsp;W：<el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[23].ln_write"
                                  class="jm-input50"/>
                                &nbsp;S：<el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[23].ln_say"
                                  class="jm-input50"/>
                                &nbsp;总：<el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[23].ln_all"
                                  class="jm-input65"/>
                              </el-col>
                              <el-col :span="24">
                                <span class="jm-span">『 TOEIC 』</span>
                                L：<el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[129].ln_listen"
                                  class="jm-input50"/>
                                &nbsp;R：<el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[129].ln_read"
                                  class="jm-input50"/>
                                &nbsp;W：<el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[129].ln_write"
                                  class="jm-input50"/>
                                &nbsp;S：<el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[129].ln_say"
                                  class="jm-input50"/>
                                &nbsp;总：<el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[129].ln_all"
                                  class="jm-input65"/>
                              </el-col>
                              <el-col :span="24">
                                <span class="jm-span">『 GRE 』</span>
                                数：<el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[25].ln_read"
                                  class="jm-input50"/>
                                &nbsp;语：<el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[25].ln_write"
                                  class="jm-input50"/>
                                &nbsp;写：<el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[25].ln_say"
                                  class="jm-input50"/>
                                &nbsp;总：<el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[25].ln_all"
                                  class="jm-input65"/>
                              </el-col>
                            </el-row>
                            <el-row style="width: 100%; display: block;">
                              <el-col :span="24">
                                <span class="jm-span">『 IELTS 』</span>
                                L：<el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[22].ln_listen"
                                  class="jm-input50"/>
                                &nbsp;R：<el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[22].ln_read"
                                  class="jm-input50"/>
                                &nbsp;W：<el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[22].ln_write"
                                  class="jm-input50"/>
                                &nbsp;S：<el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[22].ln_say"
                                  class="jm-input50"/>
                                &nbsp;总：<el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[22].ln_all"
                                  class="jm-input65"/>
                              </el-col>
                              <el-col :span="24">
                                <span class="jm-span">『 CET 』</span>
                                <jm-dict-select
                                  :disabled="infoReadOnly && !isKaopei"
                                  class="jm-input135"
                                  clearable
                                  v-model="scores[671].ln_level"
                                  dict-type="exam_cet"
                                  :filter="(item) => item.pid === 671"/>
                                &nbsp;总：<el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[671].ln_all"
                                  class="jm-input65"/>
                              </el-col>
                              <el-col :span="24">
                                <span class="jm-span">『 GMAT 』</span>
                                &nbsp;写：<el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[24].ln_listen"
                                  class="jm-input50"/>
                                &nbsp;综：<el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[24].ln_read"
                                  class="jm-input50"/>
                                &nbsp;数：<el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[24].ln_write"
                                  class="jm-input50"/>
                                &nbsp;语：<el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[24].ln_say"
                                  class="jm-input50"/>
                                &nbsp;总：<el-input
                                  :readonly="infoReadOnly && !isKaopei"
                                  v-model="scores[24].ln_all"
                                  class="jm-input65"/>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="1">美国高考</el-col>
                          <el-col :span="7">
                            <span class="jm-span">『 SAT 』</span>
                            &nbsp;写：<el-input
                              :readonly="infoReadOnly && !isKaopei"
                              v-model="scores[661].ln_read"
                              class="jm-input50"/>
                            &nbsp;阅：<el-input
                              :readonly="infoReadOnly && !isKaopei"
                              v-model="scores[661].ln_write"
                              class="jm-input50"/>
                            &nbsp;数：<el-input
                              :readonly="infoReadOnly && !isKaopei"
                              v-model="scores[661].ln_say"
                              class="jm-input50"/>
                            &nbsp;总：<el-input
                              :readonly="infoReadOnly && !isKaopei"
                              v-model="scores[661].ln_all"
                              class="jm-input65"/>
                          </el-col>
                          <el-col :span="16">
                            <span class="jm-span">『 ACT 』</span>
                            &nbsp;英：<el-input
                              :readonly="infoReadOnly && !isKaopei"
                              v-model="scores[478].ln_listen"
                              class="jm-input50"/>
                            &nbsp;数：<el-input
                              :readonly="infoReadOnly && !isKaopei"
                              v-model="scores[478].ln_read"
                              class="jm-input50"/>
                            &nbsp;科：<el-input
                              :readonly="infoReadOnly && !isKaopei"
                              v-model="scores[478].ln_write"
                              class="jm-input50"/>
                            &nbsp;阅：<el-input
                              :readonly="infoReadOnly && !isKaopei"
                              v-model="scores[478].ln_say"
                              class="jm-input50"/>
                            &nbsp;总：<el-input
                              :readonly="infoReadOnly && !isKaopei"
                              v-model="scores[478].ln_all"
                              class="jm-input65"/>
                          </el-col>
                        </el-row>
                      </el-collapse-item>
                      <el-collapse-item
                        title="申请信息"
                        name="6"
                        v-if="!isSnapshot && hiddenIs"
                        class="basic-table basic-table-info">
                        <el-row v-if="userid">
                          <el-col :span="1">选校信息</el-col>
                          <el-col :span="23">
                            <el-button
                              v-if="!infoReadOnly"
                              size="small"
                              type="primary"
                              @click="dialogVisibleSchool = true">添加</el-button>
                          </el-col>
                        </el-row>
                        <el-row v-if="editData.schools && editData.schools.length > 0">
                          <el-col :span="5">学校</el-col>
                          <el-col :span="5">研究科(日本大学)</el-col>
                          <el-col :span="5">专业</el-col>
                          <el-col :span="3">状态</el-col>
                          <el-col :span="4">原因</el-col>
                          <el-col :span="2" style="justify-content: flex-start; font-size: 12px; padding-left: 10px">操作</el-col>
                        </el-row>
                        <!--穿梭框 追加数据 S-->
                        <template v-if="editData.schools && editData.schools.length > 0">
                          <el-row
                            v-for="(item, index) in editData.schools"
                            :key="index">
                            <el-col :span="5">
                              <input
                                type="hidden"
                                v-model="item.sh_id">
                              {{ item.sh_name !== null && item.sh_name !== '' ? item.sh_name : '无' }}
                            </el-col>
                            <el-col :span="5">
                              <input
                                type="hidden"
                                v-model="item.org_id">
                              {{ item.org_name !== null && item.org_name !== '' ? item.org_name : '无' }}
                            </el-col>
                            <el-col :span="5">
                              <input
                                type="hidden"
                                v-model="item.pf_id">
                              {{ item.pf_name !== null && item.pf_name !== '' ? item.pf_name : '无' }}
                            </el-col>
                            <el-col :span="3">
                              <jm-dict-select
                                :disabled="infoReadOnly"
                                class="jm-input135"
                                clearable
                                type="dataset"
                                v-model="item.status"
                                dict-type="student"
                                name="chooseInfo"/>
                            </el-col>
                            <el-col :span="4">
                              <template v-if="item.status === 2">
                                <el-input
                                  :readonly="infoReadOnly"
                                  type="textarea"
                                  :rows="2"
                                  placeholder="请输入内容"
                                  v-model="item.message"/>
                              </template>
                              <template v-else>无</template>
                            </el-col>
                            <el-col :span="2" style="justify-content: flex-start; padding-left: 10px">
                              <span
                                class="btn-send-msg"
                                v-if="item.id > 0 && item.status !=='' && item.status !==0 && item.status !==5"
                                @click="sendMsg(item)">发送短信</span>
                              <el-button
                                size="small"
                                type="primary"
                                @click="deleteTrdata(item, index)">删除</el-button>
                            </el-col>
                          </el-row>
                        </template>
                        <!--穿梭框 追加数据 E-->
                        <el-row>
                          <el-col :span="1">备注</el-col>
                          <el-col :span="23">
                            <el-input
                              :readonly="infoReadOnly"
                              type="textarea"
                              :rows="2"
                              placeholder="请输入内容"
                              v-model="editData['crm_school_memo']"/>
                          </el-col>
                        </el-row>
                        <el-row v-show="showCourseDetail(30)">
                          <el-col
                            :span="1"
                            style="height: 91px;">英国申请课程</el-col>
                          <el-col
                            :span="23"
                            style="height: 91px;">
                            <el-checkbox-group v-model="editData['custom_course']">
                              <el-checkbox
                                :disabled="infoReadOnly"
                                v-for="item in courses['30']"
                                :key="item.id"
                                :label="item.id">{{ item.value }}</el-checkbox>
                            </el-checkbox-group>
                          </el-col>
                        </el-row>
                        <el-row v-show="showCourseDetail(31)">
                          <el-col
                            :span="1"
                            style="height: 91px;">澳洲申请课程</el-col>
                          <el-col
                            :span="23"
                            style="height: 91px;">
                            <el-checkbox-group v-model="editData['custom_course']">
                              <el-checkbox
                                :disabled="infoReadOnly"
                                v-for="item in courses['31']"
                                :key="item.id"
                                :label="item.id">{{ item.value }}</el-checkbox>
                            </el-checkbox-group>
                          </el-col>
                        </el-row>
                        <el-row v-show="showCourseDetail(83) || showCourseDetail(485)">
                          <el-col
                            :span="1"
                            style="height: 91px;">日本申请课程</el-col>
                          <el-col
                            :span="23"
                            style="height: 91px">
                            <el-checkbox-group v-model="editData['custom_course']">
                              <el-checkbox
                                :disabled="infoReadOnly"
                                v-for="item in courses['83']"
                                :key="item.id"
                                :label="item.id">{{ item.value }}</el-checkbox>
                            </el-checkbox-group>
                          </el-col>
                        </el-row>
                        <el-row v-show="showCourseDetail(471)">
                          <el-col
                            :span="1"
                            style="height: 91px;">美国申请课程</el-col>
                          <el-col
                            :span="23"
                            style="height: 91px;">
                            <el-checkbox-group v-model="editData['custom_course']">
                              <el-checkbox
                                :disabled="infoReadOnly"
                                v-for="item in courses['471']"
                                :key="item.id"
                                :label="item.id">{{ item.value }}</el-checkbox>
                            </el-checkbox-group>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col
                            :span="1"
                            style="height: 110px;">申请专业</el-col>
                          <el-col
                            :span="23"
                            style="height: 110px;">
                            <el-checkbox-group v-model="editData['custom_hope_way']">
                              <el-checkbox
                                :disabled="infoReadOnly"
                                v-for="item in direction"
                                :key="item.id"
                                :label="item.id">{{ item.value }}</el-checkbox>
                            </el-checkbox-group>
                          </el-col>
                        </el-row>
                      </el-collapse-item>
                      <el-collapse-item
                        title="1对1升学规划"
                        name="7"
                        v-if="!isSnapshot && hiddenIs"
                        class="basic-table">
                        <el-row>
                          <el-col
                            :span="1"
                            class="scores-info">
                            <el-row>
                              <el-col>是否参与</el-col>
                              <el-col/>
                              <el-col/>
                            </el-row>
                          </el-col>
                          <el-col
                            :span="23"
                            class="scores-jmte">
                            <el-row style="width: 40%; display: block;">
                              <el-col :span="24">
                                <el-checkbox
                                  :true-label="1"
                                  :false-label="0"
                                  :disabled="infoReadOnly"
                                  v-model="editData['join_upgrade_plan']">参加1对1升学规划</el-checkbox>
                              </el-col>
                              <el-col :span="24">
                                <el-checkbox
                                  :true-label="1"
                                  :false-label="0"
                                  :disabled="infoReadOnly"
                                  v-model="editData['send_upgrade_plan']">发送升学规划书</el-checkbox>
                              </el-col>
                              <el-col :span="24">
                                <el-checkbox
                                  :true-label="1"
                                  :false-label="0"
                                  :disabled="infoReadOnly"
                                  v-model="editData['test_upgrade_plan']">参加试听课程</el-checkbox>
                              </el-col>
                            </el-row>
                            <el-row style="width: 100%; display: block;">
                              <el-col :span="24">
                                <el-date-picker
                                  :readonly="infoReadOnly"
                                  format="yyyy-MM-dd"
                                  value-format="yyyy-MM-dd"
                                  v-show="editData['join_upgrade_plan']"
                                  v-model="editData['join_upgrade_plan_time']"
                                  type="date"
                                  placeholder="选择日期"/>
                              </el-col>
                              <el-col :span="24">
                                <el-date-picker
                                  :readonly="infoReadOnly"
                                  format="yyyy-MM-dd"
                                  value-format="yyyy-MM-dd"
                                  v-show="editData['send_upgrade_plan']"
                                  v-model="editData['send_upgrade_plan_time']"
                                  type="date"
                                  placeholder="选择日期"/>
                              </el-col>
                              <el-col :span="24">
                                <el-date-picker
                                  :readonly="infoReadOnly"
                                  format="yyyy-MM-dd"
                                  value-format="yyyy-MM-dd"
                                  v-show="editData['test_upgrade_plan']"
                                  v-model="editData['test_upgrade_plan_time']"
                                  type="date"
                                  placeholder="选择日期"/>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="1">指导老师</el-col>
                          <el-col :span="23">
                            <el-input
                              :readonly="infoReadOnly"
                              v-model="editData['upgrade_plan_teacher']"
                              class="jm-input-common4"/>
                          </el-col>
                        </el-row>
                      </el-collapse-item>
                      <el-collapse-item
                        title="财务信息"
                        name="8"
                        v-if="!isSnapshot && hiddenIs"
                        class="basic-table">
                        <el-row>
                          <el-col :span="1">合同总额</el-col>
                          <el-col :span="5">
                            <el-input
                              :readonly="infoReadOnly"
                              v-model="editData['crm_money_all']"
                              class="jm-input-common4"/>
                          </el-col>
                          <el-col :span="1">首款</el-col>
                          <el-col :span="5">
                            <el-input
                              :readonly="infoReadOnly"
                              v-model="editData['crm_gathering']"
                              class="jm-input-common4"/>
                          </el-col>
                          <el-col :span="1">尾款</el-col>
                          <el-col :span="5">
                            <el-input
                              :readonly="infoReadOnly"
                              v-model="editData['crm_final_pay']"
                              class="jm-input-common4"/>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="1">首款缴费时间</el-col>
                          <el-col :span="5">
                            <el-date-picker
                              :readonly="infoReadOnly"
                              class="jm-input-common4"
                              v-model="editData['crm_gathering_time']"
                              type="date"
                              format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd"
                              placeholder="选择日期"/>
                          </el-col>
                          <el-col :span="1">尾款缴费时间</el-col>
                          <el-col :span="5">
                            <el-date-picker
                              :readonly="infoReadOnly"
                              class="jm-input-common4"
                              v-model="editData['crm_final_pay_time']"
                              type="date"
                              format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd"
                              placeholder="选择日期"/>
                          </el-col>
                          <el-col :span="1">加盟商合同编号</el-col>
                          <el-col :span="5">
                            <el-input
                              :readonly="infoReadOnly"
                              v-model="editData['jm_contract_number']"
                              class="jm-input-common4"/>
                          </el-col>
                        </el-row>
                      </el-collapse-item>
                      <el-collapse-item
                        title="注册帐号"
                        name="9"
                        v-if="!isSnapshot && hiddenIs"
                        class="basic-table">
                        <el-row>
                          <el-col :span="1">注册帐号</el-col>
                          <el-col :span="5">
                            {{ memberInfo.telphone }}
                            <!-- {{ editData.cms_member ? `${editData.cms_member.username} ${editData.cms_member.tel}`: '' }} -->
                          </el-col>
                          <el-col :span="1">注册时间</el-col>
                          <el-col :span="5">
                            {{ memberInfo.updatetime }}
                            <!-- {{ editData.cms_member ? editData.cms_member.add_time : '' }} -->
                          </el-col>
                          <el-col :span="1">帐号昵称</el-col>
                          <el-col :span="5">
                            {{ editData.cms_member ?
                              `${editData.cms_member.nickname}  toUserId: ${editData.cms_member.touserid} userId: ${editData.cms_member.userid}`
                              : ''
                            }}
                          </el-col>
                        </el-row>
                      </el-collapse-item>
                      <el-collapse-item
                        v-permission="[1, 52]"
                        title="资料备注"
                        name="10"
                        v-if="!isSnapshot && hiddenIs"
                        class="basic-table">
                        <el-row class="extraRow">
                          <el-col :span="1">文件备注</el-col>
                          <el-col :span="5">
                            <jm-upload
                              ref="upload"
                              multiple
                              :on-remove="handleExtraFileRemove"
                              :on-preview="handleExtraFilePreview"
                              :on-success="handleExtraFileSuccess"
                              :show-file-list="true"
                              :file-list="editData.extra_memo_files"
                              :limit="10"
                              action="/newfib.php/job/Attach/uploadFile">
                              <el-button
                                size="small"
                                type="primary">选取文件</el-button>
                            </jm-upload>
                          </el-col>
                          <el-col :span="1">备注说明</el-col>
                          <el-col :span="13">
                            <el-input
                              type="textarea"
                              resize="none"
                              :rows="2"
                              v-model="editData['extra_memo_text']"
                              class="jm-input-common4"/>
                          </el-col>
                        </el-row>
                      </el-collapse-item>
                    </div>
                    <el-collapse-item
                      v-if="false && isKaopei && !isTrainingSite"
                      title="考培信息"
                      name="9"
                      class="basic-table">
                      <!-- 1,62,80,81 -->
                      <el-row>
                        <el-col :span="1">签约信息</el-col>
                        <el-col :span="5">
                          <jm-dict-select
                            @change="bindKaopeiSignStatus"
                            class="jm-input220"
                            clearable
                            type="dataset"
                            v-model="editData['sign_the_contract']"
                            dict-type="student"
                            name="customLevelType"/>
                        </el-col>
                        <el-col :span="1">签约日期</el-col>
                        <el-col :span="5">
                          <el-date-picker
                            class="jm-input220"
                            v-model="editData['culture_sign_date']"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="选择日期"/>
                        </el-col>
                        <el-col :span="1">客户分级</el-col>
                        <el-col :span="11">
                          <jm-dict-select
                            class="jm-input220"
                            type="dataset"
                            @change="bindKaopeiStatus"
                            v-model="editData['examination_of_culture']"
                            dict-type="student"
                            name="customLvType"
                            :filter="crmKaopeiFilter"/>
                        </el-col>
                      </el-row>
                    </el-collapse-item>
                  </el-collapse>
                </el-form>
              </div>
              <div v-if="isFibSite" style="margin-top: 20px">
                <div class="common-new-title mode2">
                  <span>活动记录</span>
                </div>
                <jm-tableList
                  url="/index/student/showActivityLog"
                  :search-data="{userid: $route.params.id}"
                  row-key="id"
                >
                </jm-tableList>
              </div>
              <div v-if="userid && !isSnapshot" style="margin-top: 8px">
                <visit
                  title="学生回访"
                  :user-id="userid"
                  :data-url="`/index/visit/paginate/userid/${userid}`"
                  delete-url="/index/visit/resource/id/"
                  :btn-opt-permission="!$hasPermission([140, 141], true) && (!infoReadOnly || isSpecialUser) && isFibSite"
                  :table-opt-permission="!$hasPermission([140, 141], true) && !infoReadOnly && isFibSite"
                  ref="studentVisit"
                  @afterSave="afterVisitAdd"
                  :crm_level='crm_level_type'
                />
                <visit
                  title="运营回访"
                  :user-id="userid"
                  :data-url="`/index/operate_visit/paginate/userid/${userid}`"
                  delete-url="/index/operate_visit/resource/id"
                  type="fibOperate"
                  :crm-level-lv="editData.crm_level_lv"
                  :other-pushed="editData.other_pushed"
                  :crm_sayer="editData.crm_sayer"
                  :btn-opt-permission="$hasPermission(117) && isFibSite"
                  :table-opt-permission="(!infoReadOnly || this.$hasPermission(117)) && isFibSite"
                />
                <visit
                  title="文案回访"
                  :user-id="userid"
                  type="writeOperate"
                  :data-url="`/index/write_visit/paginate/userid/${userid}`"
                  delete-url="/index/write_visit/resource/id/"
                  :btn-opt-permission="!$hasPermission([140, 141], true) && (!infoReadOnly || isSpecialUser) && isFibSite"
                  :table-opt-permission="!$hasPermission([140, 141], true) && !infoReadOnly && isFibSite"
                  ref="writeVisit"
                  @afterSave="afterVisitAdd"
                />
                <!--客服回访-->
                <customer-service-log
                  :user-id="userid"
                  :btn-opt-permission="!$hasPermission([140, 141], true) && (!infoReadOnly || isSpecialUser) && isFibSite"
                  :table-opt-permission="!$hasPermission([140, 141], true) && !infoReadOnly && isFibSite"
                  :data-url="`/index/customer_service_visit/paginate/userid/${userid}`"
                />
                <visit
                  title="规划回访"
                  :user-id="userid"
                  type="planningOperate"
                  :data-url="`/index/plan_visit/paginate/userid/${userid}`"
                  delete-url="/index/plan_visit/resource/id/"
                  :btn-opt-permission="$hasPermission([140, 141]) && isFibSite"
                  :table-opt-permission="(this.$hasPermission([140, 141]) || !infoReadOnly) && isFibSite"
                  ref="planVisit"
                  no-appointment
                />
                <div class="common-new-title mode2" v-if="$hasPermission([20, 54, 101]) && isFibSite && hiddenIs">
                  <span>被介绍人</span>
                </div>
                <jm-tableList
                  v-if="$hasPermission([20, 54, 101]) && isFibSite && hiddenIs"
                  url="/index/student/showBindUserData"
                  :search-data="{userid: $route.params.id}"
                  :page-size="showBindData.pageSize"
                  :refresh.sync="showBindData.isSearch"
                  row-key="id"
                >
                </jm-tableList>
                <jm-tableList
                  v-if="isFibSite && hiddenIs"
                  url="/index/vip/showVipData"
                  :search-data="{userid: $route.params.id}"
                  :page-size="showVipData.pageSize"
                  :refresh.sync="showVipData.isSearch"
                  row-key="id"
                >
                  <el-table-column
                    label="权益服务内容"
                    slot="content"
                  >
                    <template slot-scope="scope">
                      <div v-if="scope.row.type === 1">
                        发送邮箱:<el-input v-model="scope.row.email" class="input_class"></el-input>
                      </div>
                      <div v-else-if="scope.row.type === 2">
                        接机时间:<el-input v-model="scope.row.plane_time" class="input_class"></el-input><br><br>
                        接机地点:<el-input v-model="scope.row.plane_address" class="input_class"></el-input>
                      </div>
                      <div v-else-if="scope.row.type === 3">
                        预约项目:<el-input v-model="scope.row.vip_name" class="input_class" disabled="disabled"></el-input>
                      </div>
                      <div v-else-if="scope.row.type === 4">
                        电话号码:<el-input v-model="scope.row.phone" class="input_class"></el-input>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    fixed="right"
                    slot="lastColumn"
                    label="操作"
                    min-width="80"
                    class-name="scope-button-list">
                    <template slot-scope="scope">
                      <el-row v-if="!scope.row.is_other">
                        <el-button
                          size="mini"
                          type="primary"
                          @click="handleSaveData(scope.row)">保存</el-button>
                        <el-button
                          size="mini"
                          type="failed"
                          @click="handleChangeStatus(scope.row)">处理</el-button>
                      </el-row>
                    </template>
                  </el-table-column>
                </jm-tableList>
                <jm-tableList
                  v-if="$hasPermission([20, 33, 101]) && isFibSite && hiddenIs"
                  url="/index/vip/showConsultVipData"
                  :search-data="{userid: $route.params.id}"
                  :page-size="showVipData.pageSize"
                  :refresh.sync="showVipData.isSearch"
                  row-key="id"
                >
                  <el-table-column
                    fixed="right"
                    slot="lastColumn"
                    label="操作"
                    min-width="80"
                    class-name="scope-button-list">
                    <template slot-scope="scope">
                      <el-row v-if="!scope.row.is_other">
                        <el-button
                          size="mini"
                          type="failed"
                          @click="handleChangeConsultStatus(scope.row)">处理</el-button>
                      </el-row>
                    </template>
                  </el-table-column>
                </jm-tableList>
              </div>
              <div
                class="basic-buttom"
                style="margin-bottom: 20px"
                v-if="isFibSite && !isSnapshot && (!$hasPermission([89]) || $hasPermission([1]))">
                <el-button
                  type="primary"
                  v-if="canEditManager || canEditSayer || !infoReadOnly || isKaopei || canEditByCreator"
                  :loading="saving"
                  @click="handleSave()" :disabled="this.userInfo.userid === 2243703 && editData['crm_level_lv'] === 58">保存</el-button>
                <el-button
                  type="primary"
                  v-if="!infoReadOnly || isKaopei"
                  :loading="saving"
                  class="jm-button-normal"
                  :disabled="this.userInfo.userid === 2243703 && editData['crm_level_lv'] === 58"
                  @click="handleSave(true)">保存并新建</el-button>
                <el-button
                  type="primary"
                  v-if="!isNew && isFibSite && $hasPermission([22, 33, 39, 44, 45, 46, 51, 75, 93, 101, 121, 122, 148, 149, 173])"
                  @click="fibSyncDataLoaded = !fibSyncDataLoaded"
                >业务内推</el-button>
                <template v-if="!isNew && isFibSite && ($hasPermission([19, 20, 22, 33, 38, 39, 40, 43, 44, 45, 46, 51, 54, 58, 75, 93, 101, 124, 141, 147, 162]) || $store.getters.userInfo.userid === editData.crm_sayer || $store.getters.userInfo.userid === editData.crm_writer || $store.getters.userInfo.userid === editData.crm_planning)">
                  <el-button
                    type="danger"
                    class="jm-button-normal jm-button-search"
                    v-if="!syncDialog.finished"
                    @click="showSyncDialog"
                    :disabled="this.userInfo.userid === 2243703 && editData['crm_level_lv'] === 58"
                  >同步到其他系统</el-button>
                  <el-button
                    v-if="syncDialog.linked"
                    type="primary"
                    class="jm-button-normal jm-button-search"
                    @click="showSyncMsgDialog"
                  >资源动态提醒</el-button>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-button
      v-if="!infoReadOnly || canEditByCreator"
      class="edit-fixed"
      type="primary"
      size="mini"
      :loading="saving"
      @click="handleSave()">保存</el-button>
    <el-dialog
      title="院校搜索"
      :visible.sync="dialogVisibleSchool"
    >
      <jm-alertTransfer @cascader-data="cascaderData"/>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="dialogVisibleSchool = false">关 闭</el-button>
        <el-button
          type="primary"
          @click="transferAdd">添 加</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="发送短信"
      :visible.sync="dialogVisibleMsg"
    >
      <jm-alertText :send-data="sendData"/>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="dialogVisibleMsg = false">取 消</el-button>
        <el-button
          type="primary"
          @click="sendMessage()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="国别内推"
      :visible.sync="fibSyncDataLoaded"
      class="basic-table"
    >
      <el-row>
        <el-col :span="7">
          原国家：
        </el-col>
        <el-col :span="17">
          <el-select v-model="fibSyncData['old_country']">
            <el-option
              v-for="item in fibSyncCountries"
              :label="item.value"
              :key="item.id"
              :value="item.id"
            />
          </el-select>
        </el-col>
        <el-col :span="7">
          原咨询老师：
        </el-col>
        <el-col :span="17">
          <el-select
            disabled
            v-model="fibSyncData['old_sayer']">
            <el-option-group v-for="(group, k) in ds['advisory_teacher']" :key="k" :label="k">
              <el-option
                v-for="item in group"
                :key="item.userid"
                :label="item.truename"
                :value="item.userid"
              />
            </el-option-group>
          </el-select>
        </el-col>
        <el-col :span="7">
          新国家：
        </el-col>
        <el-col :span="17">
          <el-select v-model="fibSyncData['new_country']">
            <el-option
              v-for="item in fibSyncCountries"
              :label="item.value"
              :key="item.id"
              :value="item.id"
            />
          </el-select>
        </el-col>
        <el-col :span="7">
          新咨询老师：
        </el-col>
        <el-col :span="17">
          <el-select
            v-model="fibSyncData['new_sayer']">
            <el-option-group v-for="(group, k) in syncTeacher" :key="k" :label="k">
              <el-option
                v-for="item in group"
                :key="item.userid"
                :label="item.truename"
                :value="item.userid"
              />
            </el-option-group>
          </el-select>
        </el-col>
      </el-row>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="fibSyncDataLoaded = false">取 消</el-button>
        <el-button
          type="primary"
          @click="sendFibSync()">确 定</el-button>
      </span>
    </el-dialog>
    <sync-dialogs
      v-if="isFibSite"
      @confirm="doSync"
      @loaded="syncDataLoaded"
      :type="syncType"
      width="30%"
      :from="editData.id"
      :visible.sync="syncDialogVisible">
    </sync-dialogs>
    <view-large-image :visible.sync="viewImageLock" :img-url="reuseImage"></view-large-image>
  </div>
</template>
<script>
import alertTransfer from '@/components/tool/alertTransfer';
import alertText from '@/components/tool/alertText';
import student from './student';
import {
  jmAreaselect,
  jmChannel,
  jmDictSelect,
  jmEducationSelect,
  jmSchoolSearch,
  jmUploadFile,
  jmUpload
} from '@/components/tool';
import _ from 'lodash';
import * as UserApi from '@/api/user.js';
import * as TeacherApi from '@/api/teacher.js';
import { formatSelectGroupData } from '@/utils/utils.js';
import school from '@/components/order/school';
import '@/assets/jsmind/js/jsmind.js';
import '@/assets/jsmind/style/jsmind.css';
// import mindMap from '@/assets/jsmind/jsmindBase.js';
import router from '@/router';
import * as Country from '@/const/index.js';
import syncDialogsMixin from '@/components/syncDialogsMixin';
import signInfoForm from './components/signinfoForm';
import permissionMixin from './permissionMixin';
import infoMenu from '@/components/infoMenu';
import tableList from '@/components/data/tableList.vue';
import { CREATOR_FIB_TO_JOB, CREATOR_FIB_TO_TRAINING } from '@/const/sync';
import mindMap from './components/mindMap';
import interviewForm from './components/interviewForm';
import viewLargeImage from '@/components/pop/viewLargeImage';
import vueClint from 'vue';
import qcInfoForm from './components/qcInfoFrom';

const visit = () => import('@/components/visit');

const customerServiceLog = () => import('@/components/customerServiceLog');

// 择校规划单 单个毕业学校原始数据
const gschools = {
  id: null,
  crm_id: '',
  school: '',
  school_type: '4',
  wangda: '',
  pro_list: [
    {
      id: '',
      school_id: '',
      school: '',
      master_type: 0,
      crm_id: '',
      major: null,
      professional_ower: null,
      gpa_suanshu: '',
      gpa_jiaquan: '',
      gpa_jidian: '',
      use_status: 0
    }
  ]
};
export default {
  mixins: [student, permissionMixin, syncDialogsMixin],
  components: {
    'jm-alertTransfer': alertTransfer,
    'jm-alertText': alertText,
    'jm-tableList': tableList,
    'jm-school': school,
    jmChannel,
    jmAreaselect,
    jmEducationSelect,
    jmDictSelect,
    jmUploadFile,
    jmUpload,
    jmSchoolSearch,
    signInfoForm,
    infoMenu,
    mindMap,
    visit,
    interviewForm,
    customerServiceLog,
    viewLargeImage,
    qcInfoForm
  },
  beforeRouteEnter(to, from, next) {
    if (!to.params.id && (to.name === 'addStudent' || to.name === 'addBindStudent')) {
      // 添加资源
      next();
      return true;
    }
    if (['editStudent', 'viewStudentInfo', 'fib_res_viewer', 'fib_res_editor', 'fibReuseDetail'].indexOf(to.name) > -1) {
      // 编辑资源
      UserApi.getBaseInfo(to.params.id)
        .then(({ data }) => {
          next((vm) => {
            vm.setStudentData(data);
          });
        })
        .catch(() => {
          router.replace({ name: 'studentIndex' });
        });

      return true;
    }

    // 联系方式相同资源数据
    if (to.name === 'resourceSnapshotView') {
      UserApi.getUserSnapshot(to.params.id).then(({ data }) => {
        next((vm) => {
          vm.setIsSnapshot();
          vm.setStudentData(data);
        });
      });
    }
  },
  data() {
    return {
      statusModifyNow: false, // 是否是这次修改了客户分级为已签约
      countryCheckboxLock: [false, false],
      showMoneyVisible: false,
      isSnapshot: false,
      saving: false,
      isEdit: true,
      userid: 0,
      services: [], // 服务切片
      channels: '', // 渠道来源
      domicile: '', // 户籍地
      education: [], // 教育信息
      courses: [], // 相关国家课程
      direction: [], // 专业,
      exams: [], // 日语能力
      scores: [], // 成绩信息
      scoresGot: {},
      scoreTypes: {}, // 成绩类型
      scoreInited: false,
      ds: {
        material: []
      },
      value: '',
      dialogVisibleSchool: false,
      dialogVisibleMsg: false,
      hiddenIs: false, // 默认显示 基本信息 签约信息
      qcrbPropIs: false, // 是否显示前程日本
      editCascaderData: [], // 穿梭框 子层每次只会有一条原始数据
      subscribeData: [], // 弹层数据 预约回访
      updateEdit: {}, // 学生回访列表 单个编辑数据
      visitUserid: {}, // userid
      customerTeacher: null, // 客服
      IshandleAppointment: false,
      IsHandleVisit: false,
      activeNames: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'interview_from_basic', 'interview_from_relation'],
      mindNames: ['1'],
      singapore_explain: [{
        value: '新加坡',
        label: '新加坡'
      }, {
        value: '马来西亚',
        label: '马来西亚',
      }],
      editData: {
        id: 0,
        create_person: null,
        create_point: -287,
        custom_promoter: null,
        custom_hope_country: [], // 意向国家
        thinking_pic: [], // 脑图,
        custom_course: [], // 课程
        custom_hope_way: [], // 专业
        custom_refusal: null,
        upgrade_plan_teacher: '',
        crm_sayer: -1,
        deleteSchoolIds: [], // 删除选校信息
        schools: [], // 选校信息数据
        country_business: null,
        join_upgrade_plan: null,
        test_upgrade_plan: null,
        send_upgrade_plan: null,
        custom_education: null,
        custom_detail: null,
        custom_place_area: null,
        custom_place_city: null,
        custom_level: null,
        crm_level_lv: null,
        crm_gathering_time: null,
        crm_final_pay_time: null,
        crm_cse: null,
        crm_writer: null,
        crm_document: null,
        crm_training: null,
        crm_manager: null,
        crm_planning: '',
        jm_contract_number: null,
        custom_year: null,
        custom_month: null,
        signing_date: '',
        custom_graduation: null,
        custom_birthday: '',
        join_upgrade_plan_time: null,
        send_upgrade_plan_time: null,
        test_upgrade_plan_time: null,
        custom_course_type: 0,
        identity: 0,
        has_jp_score: null,
        has_en_score: null,
        sign_the_contract: 0,
        examination_of_culture: '',
        culture_sign_date: null,
        jiemo_vip: 0,
        short_study_abroad: 0,
        extra_memo_files: [],
        extra_memo_text: '',
        jiemo_contract_sign: '',
        take_order: 0,
        take_order_number: '',
        radio_and_check: '',
        student_level: '',
        singapore_explain: '',
        bind_name: '',
        money: 0,
        target_college: 0,
        signing_contract_date: '',
        signing_contract_flag: '',
        g_school_list: [],
        is_parent_community: 0,
        is_vip: 0,
        wxid_file: '',
        dzxy_file: ''
      },
      originLevel: 50,
      sendData: {}, // 发送短信临时数据
      rules: {
        crm_tel: [{ required: true, message: '请输入电话', trigger: 'blur' }]
      },
      mindDataText: '',
      signTypeLevel: null,
      signTypeKind: [],
      is_level_lv: '', // 初始化的客户分级
      is_crm_training: '',
      is_crm_sayer_same: '',
      is_crm_sayer: false,
      pushMessageFormVisibleOther: false,
      operateRefresh: false, // 运营回访，刷新
      fibRefresh: false, // 运营回访，刷新
      showVipData: {
        isSearch: false,
        pageSize: 10
      },
      showBindData: {
        isSearch: false,
        pageSize: 10
      },
      fibSyncData: {
        old_country: '',
        old_sayer: '',
        new_country: '',
        new_sayer: -1,
        crm_id: 0
      },
      syncTeacher: [],
      fibSyncDataLoaded: false,
      vipArr: [],
      crm_level_type: null,
      crm_planning_mounted: null,
      channelFinal: false,
      gschoolList: [Object.assign({}, gschools)], // 毕业学校
      isRadio: '00', // 是否使用GPA
      siteName: process.env.VUE_APP_SITE_NAME,
      viewImageLock: false,
      reuseImage: ''
    };
  },
  methods: {
    viewBigImg(url) {
      if (url) {
        this.reuseImage = url;
        this.viewImageLock = true;
      } else {
        this.$message.error('图片路径错误');
      }
    },
    downloadWxid() {
      window.open(this.$jiemo.imghome + this.editData.wxid_file);
    },
    uploadWxidSuccess({ msg, result, data }) {
      if (result === -1) {
        this.$message.error(msg);
        return false;
      }
      this.$message.success('微信名片上传成功');
      this.editData.wxid_file = data.path;
    },
    addNewschool() {
      // 新增毕业学校
      this.gschoolList.push(Object.assign({}, this.gschools()));
    },
    // GPA单选赋值
    gpaRadioEach() {
      this.gschoolList.forEach((item, Idx) => {
        item.pro_list.forEach((proItem, proIdx) => {
          if (proItem.use_status === 1) {
            this.isRadio = `${Idx}${proIdx}`;
          }
        });
      });
    },
    gschools() {
      // 新增毕业学校结构
      return {
        id: null,
        crm_id: '',
        school: '',
        school_type: '4',
        wangda: '',
        iscan: true,
        pro_list: [
          {
            id: '',
            school_id: '',
            school: '',
            master_type: 0,
            crm_id: '',
            major: '',
            professional_ower: '',
            gpa_suanshu: '',
            gpa_jiaquan: '',
            gpa_jidian: '',
            use_status: 0
          }
        ]
      };
    },
    countryCheckboxClick(val) {
      if (val === 1) {
        vueClint.set(this.countryCheckboxLock, 0, !this.countryCheckboxLock[0]);
      }
    },
    ShowBindUser() {
      // 增加
      if (this.$route.params.bindid > 0 || this.$route.params.id > 0) {
        if (this.$route.params.bindid > 0) {
          if (this.channels === '') {
            this.channels = {
              custom_from: 7106,
              custom_from_sub: 7109,
              custom_from_thrid: '',
              custom_from_fourth: '',
              custom_from_fifth: ''
            };
          }
          this.editData.parent_id = this.$route.params.bindid;
        }
        this.$http._post({
          url: '/index/student/getNameByCrmId',
          data: { crm_id: this.editData.parent_id },
        }).then((data) => {
          if (data.data.name) {
            this.editData.bind_name = data.data.name;
          } else {
            this.editData.bind_name = '无';
          }
        });
      }
    },
    changeLink(val) {
      console.log(val);
    },
    editHidden() {
      this.hiddenIs = !this.hiddenIs;
    },
    handleSaveData(row) {
      let arr = {};
      if (row.type === 1) {
        arr.email = row.email;
      } else if (row.type === 2) {
        arr.plane_time = row.plane_time;
        arr.plane_address = row.plane_address;
      } else if (row.type === 4) {
        arr.phone = row.phone;
      }
      arr.type = row.type;
      this.vipArr = arr;
      return new Promise(() => {
        this.$http
          ._post({
            url: '/index/vip/editVipData',
            data: { id: row.id, source: this.vipArr }
          })
          .then(() => {
            this.$message({
              type: 'success',
              message: '保存成功!'
            });
            this.showVipData.isSearch = false;
          });
      });
    },
    handleChangeStatus(row) {
      return new Promise(() => {
        this.$http
          ._post({
            url: '/index/vip/changeVipStatus',
            data: { id: row.id, status: row.status }
          })
          .then(() => {
            this.$message({
              type: 'success',
              message: '处理成功!'
            });
            this.showVipData.isSearch = false;
            if (row.status === '已处理') {
              row.status = '未处理';
            } else {
              row.status = '已处理';
            }
          });
      });
    },
    handleChangeConsultStatus(row) {
      return new Promise(() => {
        this.$http
          ._post({
            url: '/index/vip/changeConsultVipStatus',
            data: { id: row.id, status: row.status }
          })
          .then(() => {
            this.$message({
              type: 'success',
              message: '处理成功!'
            });
            this.showVipData.isSearch = false;
            if (row.status === '已处理') {
              row.status = '未处理';
            } else {
              row.status = '已处理';
            }
          });
      });
    },
    /**
     * 添加学校及专业
     */
    transferAdd() {
      this.dialogVisibleSchool = false;
      if (this.editCascaderData.length <= 0) {
        this.$message.warning('没有添加选校信息');
        return false;
      }
      if (
        this.editCascaderData.length === 2 &&
        this.editCascaderData[0].use_org === 0
      ) {
        this.editCascaderData[2] = this.editCascaderData[1];
        this.editCascaderData[1] = undefined;
      }
      this.editData.schools.push({
        id: 0,
        sh_id:
          this.editCascaderData[0] !== undefined
            ? this.editCascaderData[0].id
            : null,
        sh_name:
          this.editCascaderData[0] !== undefined
            ? this.editCascaderData[0].name
            : null,
        org_id:
          this.editCascaderData[1] !== undefined
            ? this.editCascaderData[1].id
            : null,
        org_name:
          this.editCascaderData[1] !== undefined
            ? this.editCascaderData[1].name
            : null,
        pf_id:
          this.editCascaderData[2] !== undefined
            ? this.editCascaderData[2].id
            : null,
        pf_name:
          this.editCascaderData[2] !== undefined
            ? this.editCascaderData[2].name
            : null,
        smsnum: 0,
        status: 1,
        message: ''
      });
    },
    /**
     * 删除选校 信息数据 未实现
     */
    deleteTrdata(item, index) {
      this.$confirm('此操作将删除此条信息，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.editData.deleteSchoolIds.push(item.id);
          this.editData.schools.splice(index, 1);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    /**
     * 获取穿梭框子层数据
     */
    cascaderData(cb) {
      this.editCascaderData = cb;
    },
    /**
     * 设置学生信息
     */
    setStudentData(data) {
      this.editData = Object.assign(this.editData, data);
      if (this.editData.custom_hope_country.length < 1) {
        vueClint.set(this.countryCheckboxLock, 0, true);
      }
      if (this.editData.g_school_list.length !== 0) {
        this.gschoolList = this.editData.g_school_list;
        this.gpaRadioEach();
      }
      this.is_level_lv = this.editData.crm_level_lv;
      this.is_crm_training = this.editData.crm_training;
      this.is_crm_sayer_same = this.editData.crm_sayer;
      this.originLevel = this.editData.crm_level_lv;
      if (
        this.editData.crm_sayer &&
        this.editData.crm_training &&
        this.editData.crm_sayer !== this.editData.crm_training
      ) {
        this.is_crm_sayer = true;
      }
      this.formatStudentData();
      this.editData.custom_course_type = this.editData.custom_course_type === 0 ? '' : this.editData.custom_course_type;

      if (!this.editData.schools) {
        this.$set(this.editData, 'schools', []);
      }

      this.$set(this.editData, 'deleteSchoolIds', []);
      this.initFibSync();
      this.initChannels();
      this.initSignType();
    },
    /**
     * 初始化签约类型
     */
    initFibSync() {
      this.fibSyncData.old_sayer = this.editData.crm_sayer;
      this.fibSyncData.crm_id = this.editData.id;
    },
    /**
     * 初始化签约类型
     */
    initSignType() {
      let signType = this.editData.sign_type || '';
      signType.split(',').forEach((item) => {
        item = +item;
        if (item < 4) {
          this.signTypeLevel = item;
        } else {
          this.signTypeKind.push(item);
        }
        this.editData.radio_and_check = this.getSignType();
      });
    },
    /**
     * 格式化学校信息。处理一些数据信息
     */
    formatStudentData() {
      if (this.editData.custom_year !== null) {
        this.editData.custom_year = String(this.editData.custom_year);
      }
      if (this.editData.custom_month !== null) {
        this.editData.custom_month = String(this.editData.custom_month);
      }
      if (this.editData.custom_graduation !== null) {
        this.editData.custom_graduation = String(this.editData.custom_graduation);
      }
    },
    /**
     * 初始化用户数据
     */
    getStudent() {
      const userid = this.$route.params.id;
      if (!userid) {
        return Promise.resolve(false);
      }
      return UserApi.getBaseInfo(userid).then(({ data }) => {
        this.setStudentData(data);
      });
    },
    initEducation() {
      this.education = [
        this.editData.custom_education,
        this.editData.custom_detail
      ];
    },
    setEducation() {
      // if (this.hiddenIs) {
      // 如果未展示教育信息未进行初始化，导致 this.eduction 未付值
      this.editData.custom_education = this.education[0];
      this.editData.custom_detail = this.education[1];
      // }
    },
    /**
     * 填充用户户籍地信息
     */
    initDomicile() {
      this.domicile = [
        this.editData.custom_place_area,
        this.editData.custom_place_city
      ];
    },
    /**
     * 设置用户户籍地
     */
    setDomicile() {
      // if (this.hiddenIs) {
      this.editData.custom_place_area = this.domicile[0];
      this.editData.custom_place_city = this.domicile[1];
      // }
    },
    /**
     * 初始化渠道字典
     */
    initChannels() {
      this.channels = {
        custom_from: this.editData.custom_from,
        custom_from_sub: this.editData.custom_from_sub,
        custom_from_thrid: this.editData.custom_from_thrid,
        custom_from_fourth: this.editData.custom_from_fourth,
        custom_from_fifth: this.editData.custom_from_fifth
      };
    },
    /**
     * 处理分数信息
     */
    tidyScores() {
      let scores = { ...this.scores };
      Object.entries(scores).forEach((item) => {
        let hasValue = false;
        Object.values(item[1]).forEach((v) => {
          if (v) {
            hasValue = true;
          }
        });
        if (!hasValue) {
          delete scores[item[0]];
        } else {
          item[1] && (item[1].ln_type = item[0]);
        }
      });
      return scores;
    },
    /**
     * 清除资源联系方式
     */
    resetStudentContactInfo() {
      this.editData.crm_tel = null;
      this.editData.crm_weixin = null;
      this.editData.crm_qq = null;
    },
    /**
     * 重置用户渠道来源
     */
    resetStudentChannel() {
      this.editData.custom_from = null;
      this.editData.custom_from_sub = null;
      this.editData.custom_from_thrid = null;
      this.editData.custom_from_fourth = null;
      this.editData.custom_from_fifth = null;
      this.initChannels();
    },
    /**
     * 判断财力显示
     */
    showMoney() {
      if (Object.keys(this.editData.custom_hope_country).length === 0) {
        this.showMoneyVisible = false;
        return;
      }
      // 日本、韩国、美国、加拿大、新/马
      let showMoney = [83, 672, 471, 486, 2061];
      let countrys = this.editData.custom_hope_country;
      // for (let i in countrys) {
      //   if (showMoney.indexOf(countrys[i]) !== -1) {
      //     this.showMoneyVisible = true;
      //     return;
      //   }
      // }
      Object.keys(countrys).forEach((key) => {
        if (showMoney.indexOf(countrys[key]) !== -1) {
          this.showMoneyVisible = true;
        }
      });
      if (this.showMoneyVisible) {
        return;
      }
      this.showMoneyVisible = false;
    },
    /**
     * 重置咨询资源信息
     */
    resetEditData() {
      Object.entries(this.editData).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          this.editData[key] = [];
          return true;
        }
        if (key === 'create_person' || key === 'crm_sayer') {
          return true;
        }
        if (key === 'custom_course_type') {
          this.editData[key] = 0;
        } else {
          this.editData[key] = null;
        }
      });
      this.resetStudentContactInfo();
      this.resetStudentChannel();
      this.gschoolList = [Object.assign({}, this.gschools())];
      this.editData.crm_level_lv = 50;
      this.crm_planning_mounted = this.editData.crm_planning;
    },
    /**
     * 保存请求
     */
    saveAjax(student, create, showNotify) {
      // 保存报名表数据
      if (this.$refs.interviewForm) {
        this.$refs.interviewForm.saveFormData(student);
      }
      // eslint-disable-next-line no-unused-vars
      return new Promise((resolve, reject) => {
        this.$http
          ._post({
            url: '/index/student/save',
            data: student
          })
          .then(({ data, msg }) => {
            this.$store.commit('upClickSave', false);
            showNotify && this.$message.success(msg || '保存成功');
            this.originLevel = student.crm_level_lv;
            this.saving = false;
            // this.clickSave = false;
            if (this.isNew) {
              this.resetStudentContactInfo();
            }
            if (create) {
              this.resetEditData();
              if (!this.isNew) {
                this.$router.push({ name: 'addStudent' });
              }
              return resolve(true);
            }
            if (this.isNew) {
              setTimeout(() => {
                window.location.href = '/frontend/student';
              }, 1000);
            }

            this.scores = Object.assign(this.scores, data);
            if (data.teacher_give_up) {
              setTimeout(() => {
                window.location.href = '/frontend/student';
              }, 1000);
            }
            if (!this.isNew) {
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
            return resolve(data);
          })
          // eslint-disable-next-line no-unused-vars
          .catch((e) => {
            if (e.data.data === '请填写跟进回访记录') {
              setTimeout(() => {
                this.$message.closeAll();
              }, 2000);
              this.crm_level_type = 55;
              this.$refs.studentVisit.visitHandle({ crmid: this.userid }, 'visit', '快捷回访', 'increase');
            } else if (e.data.data === '请填写回访记录') {
              setTimeout(() => {
                this.$message.closeAll();
              }, 2000);
              this.crm_level_type = 0;
              this.$refs.studentVisit.visitHandle({ crmid: this.userid }, 'visit', '快捷回访', 'increase');
            }
            this.saving = false;
            // return reject(e);
          });
      });
    },
    /**
     * 保存学生信息
     *
     * @param  {Boolean} create 是否为保存并新建
     */
    handleSave(create = false, showNotify = true) {
      // 签约校验
      if (this.editData.custom_level === 7) {
        if (!this.editData.custom_birthday) {
          this.$message.error('已签约资源需要填写生日，请补全。');
          return false;
        }
        if (this.domicile === '' || !this.domicile[1]) {
          this.$message.error('已签约资源需要填写户籍地，请补全。');
          return false;
        }
        if (!this.editData.custom_sex) {
          this.$message.error('已签约资源需要填写性别，请补全。');
          return false;
        }
        if (this.education === '' || !this.education[0]) {
          this.$message.error('已签约资源需要填写最高学历，请补全。');
          return false;
        }
        if (!this.gschoolList[0].school) {
          this.$message.error('已签约资源需要毕业学校，请补全。');
          return false;
        }
      }
      if (this.crm_planning_mounted !== this.editData.crm_planning) {
        this.$refs.studentVisit.visitHandle({ crmid: this.userid }, 'visit', '快捷回访', 'increase');
        return Promise.reject(new Error('请添加学生回访'));
      }
      if (!this.hasContactInfo(this.editData.crm_tel, this.editData.crm_weixin)) {
        if (this.userid && !this.hasContactInfo(this.editData.crm_qq)) {
          this.$message.error('请填写联系方式');
          this.$refs.telInput.focus();
          return Promise.reject(new Error('请填写联系方式'));
        }
        if (!this.userid) {
          this.$message.error('必须填写微信或手机号');
          this.$refs.telInput.focus();
          return Promise.reject(new Error('必须填写微信或手机号'));
        }
      }
      if (this.editData.crm_weixin) {
        if (this.editData.crm_weixin.indexOf(' ') > -1) {
          this.$message.error('微信号格式错误');
          return Promise.reject(new Error('微信号格式错误'));
        }
        if (this.isNew && this.editData.crm_weixin.substring(0, 4).indexOf('wxid') > -1 && this.editData.wxid_file === '') {
          this.$message.error('请上传微信名片');
          return Promise.reject(new Error('请上传微信名片'));
        }
      }
      if (this.editData.crm_qq && !this.editData.crm_qq.match(/^\d{5,}$/)) {
        this.$message.error('QQ号码格式错误');
        return Promise.reject(new Error('QQ号码格式错误'));
      }
      this.setEducation();

      // 学历本科及以上的时候 向上同步选中GPA
      // if (this.editData.custom_education > 4) {
      Object.keys(this.gschoolList).forEach((v) => {
        if (this.gschoolList[v].pro_list) {
          Object.keys(this.gschoolList[v].pro_list).forEach((vv) => {
            if (this.gschoolList[v].pro_list[vv].use_status) {
              let thisObj = this.gschoolList[v].pro_list[vv];
              this.editData.gpa_suanshu = thisObj.gpa_suanshu;
              this.editData.gpa_jiaquan = thisObj.gpa_jiaquan;
              this.editData.gpa_jidian = thisObj.gpa_jidian;
            }
          });
        }
      });
      // }
      // 合并毕业院校信息
      this.editData.g_school_list = this.gschoolList;

      if (!this.hasChannel(this.channels)) {
        this.$message.error('渠道来源必须填写');
        this.$refs.channelRef.focus();
        return Promise.reject(new Error('渠道来源必须填写'));
      } else if (!this.channelFinal) {
        this.$message.error('渠道来源必须填写完全');
        return Promise.reject(new Error('渠道来源必须填写完全'));
      }
      try {
        this.$refs.signInfoForm.checkSchoolStatus();
      } catch (e) {
        this.$message.error(e.message);
        if (e.message === '入学时间不能为空') {
          this.$refs.customer_year.focus();
        }
        return Promise.reject(e);
      }
      // 线索分级
      if (this.isNew && !this.editData.clues_level) {
        this.$message.error('请选择线索分级');
        return Promise.reject(new Error('请选择线索分级'));
      }

      if (this.isUA() && (this.editData.custom_level === 7) && !this.getSignType()) {
        this.$message.error('请选择签约类型');
        return false;
      }

      this.$store.commit('upClickSave', true);
      if (
        !this.isNew &&
        !this.$store.state.isNewVisit &&
        this.editData.crm_level_lv === 58
      ) {
        this.$refs.studentVisit.visitHandle({ crmid: this.userid }, 'visit', '快捷回访', 'increase');
        return Promise.reject(new Error('没有回访'));
      }
      if (
        this.infoReadOnly &&
        !this.isKaopei &&
        !this.isOptManager &&
        !this.canEditSayer &&
        !this.canEditManager &&
        !this.canEditByCreator
      ) {
        return Promise.reject(new Error('无权编辑'));
      }
      this.saving = true;
      this.setDomicile();
      let student = {
        ...this.editData,
        ...this.channels, // 用户渠道来源
        _scores: { ...this.scoresGot, ...this.tidyScores() },
        join_upgrade_plan_time: this.editData.join_upgrade_plan_time || null,
        send_upgrade_plan_time: this.editData.send_upgrade_plan_time || null,
        test_upgrade_plan_time: this.editData.test_upgrade_plan_time || null,
        signing_date: this.editData.signing_date || null,
        custom_birthday: this.editData.custom_birthday || null,
        crm_gathering_time: this.editData.crm_gathering_time || null,
        crm_final_pay_time: this.editData.crm_final_pay_time || null,
        custom_hope_country:
          this.editData.custom_hope_country.length > 0
            ? this.editData.custom_hope_country
            : null,
        sign_type: this.getSignType(),
        custom_sure: this.editData.cms_sayer_country,
        sign_the_contract: this.editData.sign_the_contract || 0,
        examination_of_culture: this.editData.examination_of_culture || 0,
        culture_sign_date: this.editData.culture_sign_date || null,
        jiemo_vip: this.editData.jiemo_vip || 0,
        short_study_abroad: this.editData.short_study_abroad || 0
      };
      delete student.create_time;
      delete student.lastvisittime2;
      delete student.lastvisitstr;
      delete student.lastvisitcount;
      if (!this.$hasPermission([])) {
        delete student.custom_course_type; // 签约类型
      }
      student.crm_sayer = student.crm_sayer || -1;
      if (this.$hasPermission([1, 96, 121, 122, 123, 124, 125])) {
        if (!this.editData.custom_active_country.length && this.editData.crm_level_lv === 57) {
          this.$message.error('办理国家至少选一个');
          this.saving = false;
          return;
        }
        if (!this.$route.params.id) {
          return this.confirmCountry(student, create, showNotify);
        }
        let delCountries = [];
        let activeCountriesOld = this.$refs.signInfoForm.active_countries_old;
        let activeCountryId = this.editData.custom_active_country;
        activeCountriesOld.forEach((item) => {
          if (activeCountryId.indexOf(item) === -1) {
            delCountries.push(item);
          }
        });
        this.$http
          ._post({
            url: '/index/offer/initCountryInfo',
            data: {
              crm_id: this.$route.params.id,
              country_ids: delCountries,
              del: 0
            }
          })
          .then((res) => {
            this.saving = false;
            if (res.data.not_empty === 1) {
              let confirmCountries = res.data.country_id;
              const BoxDom = this.$createElement;
              let countries = this.countries_name(confirmCountries);
              this.$confirm('提示', {
                title: '提示',
                message: BoxDom('p', null, [
                  BoxDom('span', { style: 'color: #606266' }, '以下办理国家择校规划单有数据，删除前请再次确认：'),
                  BoxDom('span', { style: 'color: red' }, `${countries}`)
                ]),
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.$http
                  ._post({
                    url: '/index/offer/initCountryInfo',
                    data: {
                      crm_id: this.$route.params.id,
                      country_ids: delCountries,
                      del: 1
                    }
                  }).then((res) => {
                    if (res.data) {
                      this.confirmCountry(student, create, showNotify);
                    }
                  });
              });
              // .catch(()=>{
              //   this.$message({
              //     type: 'info',
              //     message: '已取消删除'
              //   });
              // })
            } else {
              this.confirmCountry(student, create, showNotify);
            }
          });
      } else {
        this.confirmCountry(student, create, showNotify);
      }
    },
    /**
     * 判断当前学生意向国家是否在国家列表内
     */
    // isInHopeCountry(countries) {
    //   return countries.some((item) => {
    //     return this.editData.custom_hope_country.indexOf(item) > -1;
    //   });
    // },
    isInHopeCountry(countries) {
      return _.intersection(this.editData.custom_hope_country, countries).length > 0;
    },
    isUA() {
      let signCountry = [30, 31, 674, 673, 675, 1831, 1770];// 英国、澳洲、新西兰、爱尔兰、法国、香港
      return this.isInHopeCountry(signCountry);
    },
    /**
     * 确认办理国家
     */
    confirmCountry(student, create, showNotify) {
      // 当客户分级修改为已签约时候，弹出提示框，让老师确认签约的办理国家是否正确
      if (this.statusModifyNow) {
        this.$confirm(`请确定签约的办理国家是否是：${this.editData.custom_active_country_str}`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          return this.saveAjax(student, create, showNotify);
        }).catch(() => {
          this.saving = false;
          return false;
        });
      } else {
        return this.saveAjax(student, create, showNotify);
      }
    },
    /**
     * 国家id转换
     */
    countries_name(confirmCountries) {
      let name = [];
      let dict = this.$refs.signInfoForm.activeCountry;
      confirmCountries.forEach((item) => {
        dict.forEach((itemA) => {
          if (item === itemA.id) {
            name.push(itemA.value);
          }
        });
      });
      return name;
    },
    /**
     * 国家课程数据字典
     */
    getCountryCourse() {
      this.$http
        ._get({
          url: '/index/api_base/countryCourse'
        })
        .then((res) => {
          this.courses = _.groupBy(res.data, (o) => {
            return o.country;
          });
        });
    },
    /**
     * 专业字典
     */
    getDirectionDict() {
      this.$http
        ._get({
          url: '/index/api_base/directionDict'
        })
        .then(({ data }) => {
          this.direction = data;
        });
    },
    /**
     * 成绩类型
     */
    getExamType() {
      return this.$http
        ._get({
          url: '/index/api_base/examTypeDict'
        })
        .then(({ data }) => {
          this.scoreTypes = data.reduce((type, item) => {
            const scores = {
              ln_level: '',
              ln_say: '',
              ln_all: '',
              ln_read: '',
              ln_write: '',
              ln_listen: ''
            };
            type[item.id] || (type[item.id] = scores);
            return type;
          }, {});
          return Promise.resolve(this.scoreTypes);
        });
    },
    /**
     * 评估成绩
     */
    getScores() {
      if (this.isSnapshot) {
        return true;
      }
      if (!this.$route.params.id) {
        // 添加资源
        this.scores = this.scoreTypes;
        this.scoreInited = true;
        return true;
      }
      UserApi.getScores(this.$route.params.id).then((res) => {
        this.scores = _.reduce(
          res.data,
          (result, item) => {
            result[item.ln_type] || (result[item.ln_type] = item);
            return result;
          },
          {}
        );
        this.scores = Object.assign(this.scoreTypes, this.scores);
        this.scoreInited = true;
      });
    },
    /**
     * 检测联系方式重复
     */
    doCheckDuplication(value, type) {
      if (!value || this.isSnapshot) {
        return true;
      }
      return this.$http
        ._post({
          url: '/index/student/checkContactInfo',
          data: {
            value,
            type,
            crmid: this.userid
          }
        })
        .catch(() => {});
    },
    checkQQ(event) {
      let value = event.target.value;
      this.doCheckDuplication(value, 'qq');
    },
    checkWx(event) {
      let value = event.target.value;
      this.doCheckDuplication(value, 'wx');
    },
    checkTel(event) {
      let value = event.target.value.trim();
      this.editData.crm_tel = value;
      if (this.editData.crm_tel) {
        this.editData.crm_tel = this.editData.crm_tel.trim();
        if (!this.checkMobile(this.editData.crm_tel)) {
          this.$message.error('手机号码填写错误！');
          return false;
        }
      }
      this.doCheckDuplication(value, 'tel');
    },
    /**
     * 根据意向国家显示课程详情
     *
     * @param  {Number} countryId 国家ID
     * @return {Boolean}
     */
    showCourseDetail(countryId) {
      return this.editData.custom_hope_country.indexOf(countryId) > -1;
    },
    /**
     * 业务内推
     */
    sendFibSync() {
      if (this.fibSyncCheck()) {
        this.fibSyncDataLoaded = false;
        this.$http
          ._post({
            url: '/index/student/fibSync',
            data: this.fibSyncData
          })
          .then(({ result }) => {
            this.dialogVisibleMsg = false;
            if (result !== -1) {
              this.$message.success('发送成功');
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          });
      }
    },
    fibSyncCheck() {
      if (!this.fibSyncData.old_country) {
        this.$message.error('请选择原国家');
        return false;
      }
      if (!this.fibSyncData.new_country) {
        this.$message.error('请选择新国家');
        return false;
      }
      if (!this.fibSyncData.new_sayer) {
        this.$message.error('请选择新咨询老师');
        return false;
      }
      return true;
    },
    /**
     * 发送短信 组件传值数据
     */
    sendMsg(rows) {
      this.dialogVisibleMsg = true;
      this.sendData = rows;
    },
    /**
     * 确定发送消息
     */
    sendMessage() {
      this.$http
        ._post({
          url: '/index/student/schoolSMS',
          data: {
            crm_id: this.$route.params.id,
            school_id: this.sendData.id,
            status: this.sendData.status,
            action: 'send'
          }
        })
        .then(({ result }) => {
          this.dialogVisibleMsg = false;
          if (result !== -1) {
            this.$message.success('发送成功');
          }
        });
    },
    /**
     * 根据是否大学院选择客户经理的角色
     */
    filterManagers(teachers) {
      if (!teachers) {
        return teachers;
      }

      if (!this.editData.custom_course_type) {
        return teachers;
      }
      let currentManagers = { ...teachers };
      Object.entries(currentManagers).forEach(([char, teacher]) => {
        teacher = teacher.filter((t) => {
          if (t.userid === -1) {
            return true;
          }
          if (this.editData.custom_course_type === 1) { // 日本语言学校
            return t.roleid === 94;
          }
          if (this.editData.custom_course_type === 2) { // 前程日本研究生
            return t.roleid === 93;
          }

          return true;
        });
        currentManagers[char] = teacher;
        if (teacher.length === 0) {
          delete currentManagers[char];
        }
      });
      return currentManagers;
    },
    /**
     * 根据国家过来老师列表
     */
    filterTeachers(teachers, includeTeacherIds = []) {
      if (!teachers) {
        return teachers;
      }
      let currentTeachers = { ...teachers };
      Object.entries(currentTeachers).forEach(([char, teacher]) => {
        teacher = teacher.filter((t) => {
          // 超管
          if (t.userid === -1) {
            return true;
          }

          // 前筛咨询展示
          if (t.roleid === 161) {
            return true;
          }

          // 无效的老师
          if (includeTeacherIds.length > 0 && includeTeacherIds.indexOf(t.userid) === -1) {
            return false;
          }

          // SGU
          if (this.isInHopeCountry([2070])) {
            return t.userid === 20598; // 孙睿
          }

          // 私塾，住宿，求职
          if (this.isInHopeCountry([2069, 2130, 1880])) {
            return true;
            // return [-3].indexOf(t.country) === -1; // 排除 -3
          }

          return (
            this.editData.custom_hope_country.indexOf(t.country) > -1 ||
            // 待激活咨询
            t.country === 1808 ||
            // 考培
            // t.country === 1868 ||
            // 前程与日本
            ([20, 43].indexOf(t.roleid) !== -1 && this.isInHopeCountry([83, 485])) ||
            // 英美和日韩中心共用老师
            ([-1, -2].indexOf(t.country) !== -1 && this.isInHopeCountry(this.countryCode.concat(this.countryCode1))) ||
            // 星耀东大老师
            ([-3].indexOf(t.country) !== -1 && this.isInHopeCountry(this.countryCode2))
          );
        });
        currentTeachers[char] = teacher;
        if (teacher.length === 0) {
          delete currentTeachers[char];
        }
      });
      return currentTeachers;
    },
    /**
     * 业务协同过滤老师
     */
    filter1Teachers(teachers, teacherIds = []) {
      if (!teachers) {
        return teachers;
      }
      let currentTeachers = { ...teachers };
      Object.entries(currentTeachers).forEach(([char, teacher]) => {
        teacher = teacher.filter((t) => {
          if (t.userid === -1) {
            return true;
          }

          if (teacherIds.length > 0 && teacherIds.indexOf(t.userid) === -1) {
            return false;
          }
          return (
            this.fibSyncData.new_country === t.country ||
            // 英美和韩国中心共用老师
            ([-1, -2].indexOf(t.country) !== -1 &&
              this.countryCode.concat(this.countryCode1).indexOf(this.fibSyncData.new_country) !== -1) ||
            // 星耀东大老师
            (t.country === -3 &&
              this.countryCode2.indexOf(this.fibSyncData.new_country) !== -1)
          );
        });
        currentTeachers[char] = teacher;
        if (teacher.length === 0) {
          delete currentTeachers[char];
        }
      });
      return currentTeachers;
    },
    /**
     * 连动用户状态
     */
    bindUserStatus(val) {
      if (val === 57) {
        this.editData.custom_level = 7;
        this.statusModifyNow = true;
        return true;
      }
      if (val === 65) {
        this.editData.custom_level = 9;
        return true;
      }
      this.editData.custom_level = '';
    },
    bindUserSignStatus(val) {
      if (val === 7 && this.editData.crm_level_lv !== 57) {
        this.editData.crm_level_lv = 57;
        return true;
      }
      if (val === 9 && this.editData.crm_level_lv !== 65) {
        this.editData.crm_level_lv = 65;
      }
    },
    /**
     * 连动用户状态
     */
    bindKaopeiStatus(val) {
      if (val === 57) {
        this.editData.sign_the_contract = 7;
        return true;
      }
      if (val === 65) {
        this.editData.sign_the_contract = 9;
        return true;
      }
      this.editData.sign_the_contract = 0;
    },
    bindKaopeiSignStatus(val) {
      if (val === 7 && this.editData.examination_of_culture !== 57) {
        this.editData.examination_of_culture = 57;
        return true;
      }

      if (val === 9 && this.editData.examination_of_culture !== 65) {
        this.editData.examination_of_culture = 65;
      }
    },
    setIsSnapshot() {
      this.isSnapshot = true;
    },
    /**
     * 过滤客服分级
     */
    crmLevelFilter(item) {
      if (this.infoReadOnly && !this.isOptManager && !this.isDataAnalyst && this.canEditByCreator && this.originLevel === 64 && [51, 53, 61, 60, 57, 55, 62, 63, 65, 66].indexOf(item.value) > -1) {
        return false;
      }

      // if (item.value === 66) {
      //   return this.$hasPermission(1);
      // }
      return true;
    },
    crmKaopeiFilter(item) {
      if (
        item.value === 66 ||
        item.value === 64 ||
        item.value === 62 ||
        item.value === 63 ||
        item.value === 60
      ) {
        return false;
      }
      return true;
    },
    isDiffValue(columnName) {
      if (!this.isSnapshot) {
        return '';
      }
      return this.editData.snapshot_changed[columnName] ? 'diff_column' : '';
    },
    clearSignTypeLevel(val) {
      if (val === this.signTypeLevel) {
        this.signTypeLevel = null;
      }
    },
    radioGroupChange() {
      let data = this.getSignType();
      this.editData.radio_and_check = data;
    },
    checkboxGroupChange() {
      let data = this.getSignType();
      this.editData.radio_and_check = data;
    },
    /**
     * 签约类型
     */
    getSignType() {
      if (!this.hasSignType) {
        return '';
      }
      if (this.signTypeLevel) {
        return [this.signTypeLevel, ...this.signTypeKind].join(',');
      }
      return this.signTypeKind.join(',');
    },
    /**
     * 同步资源到其他系统
     */
    doSync({ message, targetLan, system }) {
      const notifyHandle = this.$message('同步中...');
      let url = '';
      let sycData = {};
      if (system === CREATOR_FIB_TO_TRAINING) { // 考培系统
        if (this.editData.custom_hope_country.indexOf(1868) === -1) {
          this.editData.custom_hope_country.push(1868);
        }
        url = '/index/student/syncToTraining';
        sycData = {
          id: this.editData.id,
          message,
          targetLan
        };
      }
      if (system === CREATOR_FIB_TO_JOB) { // 求职系统
        url = '/index/student/syncToJob';
        sycData = {
          id: this.editData.id,
          message,
        };
      }
      this.$http._post({
        url: url,
        data: sycData,
      }).then(() => {
        notifyHandle.close();
        this.$message.success('同步成功');
        this.syncDialogVisible = false;
      });
    },
    handleExtraFileSuccess(response) {
      if (response.result === 0) {
        this.editData.extra_memo_files.push({
          name: response.data.fileName,
          url: response.data.filePath
        });
      } else {
        this.$message({
          message: response.msg, type: 'error'
        });
      }
    },
    handleExtraFileRemove(file, fileList) {
      this.editData.extra_memo_files = fileList;
    },
    handleExtraFilePreview(file) {
      window.open(`/${file.url}`);
    },
    afterVisitAdd() {
      if (this.crm_planning_mounted !== this.editData.crm_planning) {
        this.crm_planning_mounted = this.editData.crm_planning;
      }
      this.handleSave();
    },
  },
  mounted() {
    this.userid = this.$route.params.id || null;
    // 客服
    TeacherApi.getCseTeachers().then(({ data }) => {
      this.customerTeacher = formatSelectGroupData(data);
    });
    this.$nextTick(() => {
      this.crm_planning_mounted = this.editData.crm_planning;
      this.initEducation();
      this.initDomicile();
    });
  },
  created() {
    this.$nextTick(function() {
      this.getDatasource().then((ds) => {
        this.ds.create_point = ds.create_person.ZZ;
        delete this.ds.create_person.ZZ;
        if (this.isNew) {
          // 添加
          this.editData.create_person = this.userInfo.userid;
          this.editData.custom_promoter = this.userInfo.userid;
          this.editData.crm_level_lv = 50; // 等待处理
          this.editData.custom_hope_country = this.userCountries.length === 1 ? this.userCountries : [];
          // 新建资源咨询老师赋初值
          if (this.$hasPermission([20, 23, 27, 29, 38, 40, 43, 54, 55, 56, 57, 71, 72, 80, 88, 124, 147, 149], true)) {
            this.editData.crm_sayer = this.userInfo.userid;
          } else if (this.isInHopeCountry([2070])) {
            this.editData.crm_sayer = 20598;// 孙睿
          } else {
            this.editData.crm_sayer = -1;
          }

          if (this.$hasPermission(80, true)) {
            // 考培
            this.editData.crm_training = this.userInfo.userid;
          }
        }
        this.showMoney();
        this.ShowBindUser();
      });
    });
  },
  computed: {
    /**
     * 前程日本语言
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @return {String}
     */
    signType() {
      if (!this.editData.custom_course_type) {
        return '无';
      }
      if (this.editData.custom_course_type === 1) {
        return '日本语言学校';
      }
      if (this.editData.custom_course_type === 2) {
        return '前程日本研究生';
      }
    },
    contractSign() {
      if (this.editData.jiemo_contract_sign === '1' || this.editData.jiemo_contract_sign === '1,2' || this.editData.jiemo_contract_sign === '2,1') {
        return '已确认';
      }
      return '未确认';
    },
    vipSign() {
      if (this.editData.jiemo_contract_sign === '1,2' || this.editData.jiemo_contract_sign === '2' || this.editData.jiemo_contract_sign === '2,1') {
        return '已确认';
      }
      return '未确认';
    },
    /*
    * 状态刷新
    * */
    refresh() {
      return this.$store.state.student.refresh;
    },
    /**
     * 服务切片，根据不同国家内容不同
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @return {Array}
     */
    servicesData() {
      const servicesData = this.services.filter((item) => {
        if (this.editData.custom_hope_country.indexOf(485) > -1) {
          // 前程日本服务切片和芥末日本通用
          return (
            item.country_id === 83 ||
            this.editData.custom_hope_country.indexOf(item.country_id) > -1
          );
        }
        if (item.country === '通用') {
          // 通用切片
          return true;
        }
        return this.editData.custom_hope_country.indexOf(item.country_id) > -1;
      });
      return servicesData;
    },
    /**
     * 老师数据，重新打包传递给子组件用
     */
    teachers() {
      return {
        write_teacher: this.filterTeachers(this.ds.write_teacher),
        advisory_teacher: this.filterTeachers(this.ds.advisory_teacher),
        document_teacher: this.filterTeachers(this.ds.document_teacher),
        training_teacher: this.ds.training_teacher,
        manager_teacher: this.filterManagers(this.ds.manager_teacher),
        planning_teacher: this.filterTeachers(this.ds.planning_teacher),
      };
    },
    showScores() {
      return !this.isSnapshot && this.scoreInited;
    },
    canEditTraining() {
      if (this.userInfo.userid === this.is_crm_training) {
        return true;
      }
      if (this.infoReadOnly) {
        return false;
      }
      // admin 一直可以改 如果考培字段等于userid 可以改 若无 存在咨询老师可以改
      if (this.userInfo.userid === 1) {
        return true;
      }
      if (!this.is_crm_training && this.is_crm_sayer_same) {
        return true;
      }
      return false;
    },
    /**
     * 是否有签约类型
     */
    hasSignType() {
      const enableCountry = [
        Country.COUNTRY_GB,
        // Country.COUNTRY_JP,
        Country.COUNTRY_AU,
        Country.COUNTRY_IE,
        Country.COUNTRY_NZ,
        Country.COUNTRY_SG,
        Country.COUNTRY_FR,
        Country.COUNTRY_HK
      ];
      return this.isInHopeCountry(enableCountry);
    },
    /**
     * 是否是芥末日本学生
     */
    isJiemoJpStudent() {
      const enableCountry = [Country.COUNTRY_JP];
      return this.isInHopeCountry(enableCountry);
    },
    /**
     * 是否有签约类型的starndard plus free 选项
     */
    hasStandard() {
      return this.isInHopeCountry([
        Country.COUNTRY_GB,
        Country.COUNTRY_AU,
        Country.COUNTRY_IE,
        Country.COUNTRY_NZ,
        Country.COUNTRY_SG
      ]);
    },
    hasPlus() {
      return this.isInHopeCountry([
        Country.COUNTRY_GB,
        Country.COUNTRY_AU,
        Country.COUNTRY_IE,
        Country.COUNTRY_NZ,
        Country.COUNTRY_SG,
        Country.COUNTRY_FR,
        Country.COUNTRY_HK
      ]);
    },
    canFree() {
      return this.isInHopeCountry([
        Country.COUNTRY_GB,
        Country.COUNTRY_AU,
        Country.COUNTRY_IE,
        Country.COUNTRY_NZ
      ]);
    },
    memberInfo() {
      let uCenter = this.editData.ucenter;

      if (uCenter) {
        let regFrom = uCenter.domain.split(',').reduce((tel, currentValue) => {
          switch (Number(currentValue)) {
            case 1:
              tel = `${tel} 芥末`;
              break;
            case 2:
              tel = `${tel} 前程`;
              break;
            case 3:
              break;
            default:
              break;
          }
          return tel;
        }, '');
        uCenter.telphone = `${regFrom} ${uCenter.areacode} ${uCenter.telphone}`;
        return uCenter;
      }
      return { telphone: '', updatetime: '' };
    },
    /**
     * 获取当前登录老师的国家，刨除`其他`
     */
    userCountries() {
      return this.userInfo.countries.filter((c) => {
        return c !== 1808; // 其他
      });
    },
    /**
     * 业务内推国家
     */
    fibSyncCountries() {
      return this.hopeCountries.filter((item) => {
        return [2069, 1880, 1882, 1938, 1943, 1944, 2040, 2042, 2043, 2070, 1868, 2044, 675].indexOf(item.id) === -1;
      });
    }
  },
  watch: {
    'ds.projects': function(nVal) {
      this.services = nVal;
    },
    'fibSyncData.new_country': function() {
      this.fibSyncData.new_sayer = -1;
      this.syncTeacher = this.filter1Teachers(this.ds.advisory_teacher);
    },
    isRadio(val) {
      let arr = val.split('');
      this.gschoolList.forEach((item) => {
        item.pro_list.forEach((proItem) => {
          proItem.use_status = 0;
        });
      });
      this.gschoolList[arr[0]].pro_list[arr[1]].use_status = 1;
    },
    'editData.custom_hope_country'(val) {
      val.indexOf(485) !== -1
        ? (this.qcrbPropIs = true)
        : (this.qcrbPropIs = false);
      if (val.length === 0) {
        this.editData.country_business = null;
      }
      // 考培
      if (val.indexOf(1868) !== -1 && !this.editData.crm_training) {
        this.editData.crm_training = -1;
      }
      this.showMoney();
    },
    hiddenIs(value) {
      if (value) {
        if (this.courses.length === 0) {
          this.getCountryCourse();
        }
        if (this.direction.length === 0) {
          this.getDirectionDict();
        }

        if (this.exams.length === 0) {
          this.getExamType().then(() => {
            this.getScores();
          });
        }
      }
    },
    'editData.custom_year'(val) {
      if (!val) {
        this.editData.custom_month = null;
      }
    }
  },
};
</script>

<style lang="less">
.webimlink {
  margin-left: 12px;
  padding: 4px 10px;
  background: #409eff;
  color: #fff;
  border-radius: 4px;
}
td:nth-child(odd) {
  word-break: keep-all;
}
.basic-title {
  height: 35px;
  line-height: 35px;
  margin: 10px 8px 15px;
  position: relative;
  cursor: default;
  border-bottom: 1px solid #b8c4ce;
}
.title-bottom {
  float: right;
  margin: 0 20px;
}
.mindMapping a {
  text-decoration: underline;
  color: #000;
}
.jm-tbody-hidden {
  display: none;
}
.diff_column input.el-input__inner {
  border-color: red;
}
.diff_column .el-select input.el-input__inner {
  border-color: red;
}
</style>
<style lang="less" scoped>
.basic-information{
  width: 98%;
  margin: auto;
}
.basic-table {
  width: 100%;
}
.basic-table th {
  padding: 3px 0;
  background-color: #e2eaf0;
  border-bottom: solid 1px #b8c4ce;
  cursor: pointer;
}
.basic-table th span {
  margin-left: 10px;
}
.basic-table th i {
  font-size: 14px;
  line-height: 26px;
}
.basic-table th i:after {
  display: inline-block;
  margin-left: 10px;
  content: "\e608";
}
.basic-table /deep/ .el-row .el-col {
  display: flex;
  align-items: center;
  min-height: 55px;
  padding-left: 8px;
  border-right: solid 1px #f1f5ff;
  border-bottom: solid 1px #f1f5ff;
  font-size: 12px;
}
.basic-table /deep/ .el-row .el-col-1,
.basic-table /deep/ .el-row .el-col-2{
  justify-content: flex-end;
  padding-right: 5px;
  padding-left: 0;
  font-size: 14px;
  color: #010D2D;
  font-weight: bold;
  text-align: right;
}
.basic-table-info /deep/ .el-row:nth-child(2) .el-col {
  font-weight: bold;
}
.basic-table .scores-info .el-row .el-col {
  border-right: none;
  border-bottom: none;
  padding-left: 0;
}
.basic-table .scores-jmte {
  padding-left: 0 !important;
  border-bottom: none !important;
  border-right: none !important;
}
.jm-span {
  display: inline-block;
  width: 80px;
  text-align: right;
}
.basic-buttom {
  margin-top: 25px;
  text-align: center;
}
.btn-send-msg {
  cursor: pointer;
}
.jm-studentEditBot {
  display: block;
  height: 100%;
  opacity: 1;
  margin-top: 3px;
}
.basic-table-div /deep/ .el-form-item__content {
  line-height: inherit !important;
  font-size: 12px;
}
.input_class {
  width: 150px;
}
.hope_country{
  display: flex;
  justify-content: flex-start;
}
.hope_country>div:nth-of-type(1){
  width: 4.16667%;
}
.hope_country>div:nth-of-type(2){
  width: 95.83333%;
}
.colour{
  color: #F75694;
}
.member-tag {
  margin-right: 5px;
}
</style>
